import ManagementModule from './ManagementScreen.module.scss'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { getAssistantApi } from '../../utils/assistantApi'
import { useState, useEffect, useRef, useCallback, useContext, useMemo } from 'react'
import LoadingGrid from '../LoadingGrid/LoadingGrid'
import { getMatchingLanguage } from '../../utils/getMachingLanguage'
import SchoolUsageModal from './SchoolUsageModal'
import SchoolViewModal from './SchoolViewModal'
import StudentListModal from './StudentListModal'
import ClassRoomUsageModal from './ClassRoomUsageModal'
import { useUserDataContext } from '../../context/AuthContext'
import {
  collection,
  getDocs,
  doc,
  setDoc,
  query,
  getDoc,
  updateDoc,
  deleteDoc,
  addDoc,
  where,
  deleteField,
  collectionGroup
} from 'firebase/firestore'
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage'
import { useAuthState } from 'react-firebase-hooks/auth'
import { useNavigate } from 'react-router-dom'
import { db, auth, storage, functions } from '../../firebase'
import * as c_data from '../../localConstant'
import { useParams, useSearchParams } from 'react-router-dom'
import LinkIcon from '@mui/icons-material/Link'
import CopyToClipboard from 'react-copy-to-clipboard'
import { httpsCallable } from 'firebase/functions'
import { signInWithCustomToken } from 'firebase/auth'
import CustomWidthTooltip from '../Tooltip/Tooltip'
import Switch2 from '../Switch/Switch'
import { _fields_of_user_data_in_mypage } from '../../localConstant'
import ManagementScreenList from './ManagementScreenList'

// TODO: セレクトされたモードを管理するロジックと、編集状況を管理するロジックを分離すべき
function useEditedState(initialValue) {
  const [value, setValue] = useState(initialValue)
  const [isEdited, setIsEdited] = useState(false)
  // setValueをラップする関数
  const setEditedValue = useCallback((newValue) => {
    setValue(newValue)
    setIsEdited(true)
  }, [])
  return [value, setEditedValue, isEdited, setIsEdited]
}

function ManagementScreen({ serviceType }) {
  const {
    _responseOptions,
    _pulldownTemplates,
    _inserted_default_target_student_info,
    _language_list_v2,
    _auto_sending,
    _default_mute,
    _gpt_model,
    _question_type
  } = c_data
  const userData = useUserDataContext()

  const [constantData, setConstantData] = useState({
    _responseOptions,
    _pulldownTemplates,
    _inserted_default_target_student_info,
    _language_list_v2,
    _auto_sending,
    _default_mute,
    _gpt_model,
    _question_type
  })
  const selectedItemClassName = window.location.pathname.startsWith('/management')
    ? 'selected-item'
    : 'selected-item-interview'
  const defaultAutoSending = false
  const defaultDefaultMute = true
  const navigate = useNavigate()
  const [user] = useAuthState(auth)
  const [selectedPrompt, setSelectedPrompt, isEdited, setIsEdited] = useEditedState('')
  const [prompts, setPrompts] = useState([])
  const [categories, setCategories] = useState([])
  const [folders, setFolders] = useState([])
  const [folder, setFolder] = useState(null)
  const [folderToEdit, setFolderToEdit] = useState(null)
  const [newFolderTitle, setNewFolderTitle] = useState('')
  const prevFoldersRef = useRef(folders)
  const prevFolderRef = useRef(folder)
  const [inputResponseOptions, setInputResponseOptions] = useState(_responseOptions)
  const [inputSearchQuery, setInputSearchQuery] = useState('')
  const initialPromptState = {
    prompt_title: '',
    prompt_description: '',
    prompt_language2: JSON.stringify(_language_list_v2[0]),
    prompt_type: '',
    prompt_order: 0,
    prompt: '',
    time_window_limit: false,
    time_window: [],
    character_limit: false,
    maximum_character_count: 0,
    character_limit_per_month: false,
    maximum_character_count_per_month: 0,
    sending_count_limit: false,
    maximum_sending_count_limit: 0,
    is_past_message_limit_count_set: false,
    maximum_past_message_limit_count: 0,
    enable: false,
    responseOptions: _responseOptions,
    formQuestions: [],
    autoSending: false,
    defaultMute: true,
    temperature: 1.0,
    speakingRate: 1.1,
    model: 'azure-gpt-4o',
    largeIcon: false,
    displayInputContents: true,
    expandInputContents: false,
    useAssistantApi: false,
    availableAllSchools: false,
    availableAllClassRooms: true,
    viewableAllSchools: true,
    availableAllStudents: true,
    editable: true,
    assistantId: '',
    modeColor: '',
    customGuide: null,
    links: [],
    useDisplayMessage: false,
    isAvailableWhenDisabled: false
  }

  const [isAdmin, setIsAdmin] = useState(false)
  const [addBody, setAddBody] = useState(false)
  const [folderEditScreenShown, setFolderEditScreenShown] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [selectedLanguage2, setSelectedLanguage2] = useState('')
  const [image, setImage] = useState('')
  const [imageUrl, setImageUrl] = useState('')
  const [image2, setImage2] = useState('')
  const [imageUrl2, setImageUrl2] = useState('')
  const languageList2 = _language_list_v2
  const textAreaRef = useRef(null)
  const managementModuleRef = useRef(null)
  const [promptTitle, setPromptTitle] = useState('')
  const [pulldownTemplate, setPulldownTemplate] = useState(JSON.stringify(_pulldownTemplates[0]))
  const [searchParams] = useSearchParams()
  const uid = searchParams.get('uid')
  const muid = searchParams.get('muid')
  const schoolIdfromQueryParam = searchParams.get('school_id')
  const roleFromQueryParam = searchParams.get('role')
  const { schoolId } = useParams()
  const paramSchoolId = searchParams.get('school_id') ? searchParams.get('school_id') : schoolId
  const origin = window.location.origin
  const linkToCopy = uid
    ? `${origin}/redirect?mode=${selectedPrompt.id}&uid=${uid}`
    : `${origin}/redirect?mode=${selectedPrompt.id}`
  const linkForReproduction = uid
    ? `${origin}/clone?mode=${selectedPrompt.id}&uid=${uid}`
    : `${origin}/clone?mode=${selectedPrompt.id}`
  const [isCopied, setIsCopied] = useState(false)
  const [isModalOpen, setModalOpen] = useState(false)
  const [isStudentListModalOpen, setStudentListModalOpen] = useState(false)
  const [isSchoolUsageModalOpen, setSchoolUsageModalOpen] = useState(false)
  const [isClassRoomUsageModalOpen, setClassRoomUsageModalOpen] = useState(false)
  const [isSchoolViewModalOpen, setSchoolViewModalOpen] = useState(false)
  const [modalIndex, setModalIndex] = useState()
  const [loading, setLoading] = useState(false)
  const [loadingForStudentData, setLoadingForStudentData] = useState(false)
  const [isSwitchingBody, setIsSwitchingBody] = useState(false)
  const [documentIds, setDocumentIds] = useState([])
  const [documentIdsForStudent, setDocumentIdsForStudent] = useState([])
  const [selectedIds, setSelectedIds] = useState([])
  const [viewableSelectedIds, setViewableSelectedIds] = useState([])
  const [selectedStudentIds, setSelectedStudentIds] = useState([])
  const [additionalData, setAdditionalData] = useState(null)
  const [selectedClassRoomIds, setClassRoomSelectedIds] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [searchQueryOfClassRoom, setSearchQueryOfClassRoom] = useState('')
  const [viewableSearchQuery, setViewableSearchQuery] = useState('')
  const [searchQueries, setSearchQueries] = useState({
    schoolName: '',
    classRoom: '',
    studentName: '',
    studentId: ''
  })
  const searchFields = [
    { key: 'schoolName', placeholder: 'スクール名を検索...' },
    { key: 'classRoom', placeholder: '教室を検索...' },
    { key: 'studentName', placeholder: '生徒名を検索...' },
    { key: 'loginId', placeholder: '生徒IDを検索...' }
  ]
  const [schoolIdName, setSchoolIdName] = useState({}) // schoolIdとschoolNameの対応表
  const [studentInfoItemsForInsertion, setStudentInfoItemsForInsertion] = useState([])
  const [searchText, setSearchText] = useState('')
  const [filteredModes, setFilteredModes] = useState([])
  const [selectedAssistantApiFiles, setSelectedAssistantApiFiles] = useState([])
  const [roleInMingaku, setRoleInMingaku] = useState('')
  const [loadingText, setLoadingText] = useState('')
  const [isChildSchool, setIsChildSchool] = useState(false)
  const [isPromptCreationForbidden, setIsPromptCreationForbidden] = useState(false)
  const isAuthorizedToCreatePrompt = useMemo(() => {
    if (isAdmin) return true
    return !isPromptCreationForbidden
  }, [isAdmin, isPromptCreationForbidden])
  const path = window.location.pathname + window.location.search

  const defaultColors = [
    { label: 'brown', code: '#a52a2a' },
    { label: 'red', code: '#ff0000' },
    { label: 'pink', code: '#ff00cc' },
    { label: 'orange', code: '#ffa500' },
    { label: 'yellow', code: '#b4b432' },
    { label: 'lightgreen', code: '#50e628' },
    { label: 'green', code: '#008000' },
    { label: 'skyblue', code: '#87ceeb' },
    { label: 'blue', code: '#0000ff' },
    { label: 'navy', code: '#0b0b50' },
    { label: 'purple', code: '#800080' }
  ]
  const debounceTimeout = useRef(null)
  const onColorChange = useCallback((colorCode, option = { immediate: true }) => {
    if (typeof colorCode !== 'string') return

    if (option.immediate) {
      handleInputPromptChange({ modeColor: colorCode })
    } else {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current)
      debounceTimeout.current = setTimeout(() => {
        handleInputPromptChange({ modeColor: colorCode })
        debounceTimeout.current = null
      }, 500)
    }
  }, [])

  const onGuideChange = useCallback((guideContent, option = { default: true }) => {
    if (option.default) {
      handleInputPromptChange({ customGuide: guideContent })
    } else {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current)
      debounceTimeout.current = setTimeout(() => {
        handleInputPromptChange({ customGuide: guideContent })
        debounceTimeout.current = null
      }, 500)
    }
  }, [])

  useEffect(() => {
    if (!userData || !userData.role) {
      setIsAdmin(false)
      return
    }
    setIsAdmin(userData.role === 'admin')
  }, [userData])

  useEffect(() => {
    const fetchSystemSettings = async () => {
      try {
        const getModelSettings = async () => {
          const modelsCollectionRef = collection(db, '/models')
          const modelsSnapshot = await getDocs(modelsCollectionRef)
          const modelsDocs = modelsSnapshot.docs.map((doc) => ({
            ...doc.data()
          }))

          const gptModelValues = new Set(_gpt_model.map((gptModel) => gptModel.value))

          // Firebaseから取得したモデルのうち、_gpt_modelに存在するモデルのみを残す
          const filteredModels = modelsDocs
            .filter((model) => gptModelValues.has(model.value)) // _gpt_modelに存在するmodelだけに絞る
            .map((model) => {
              // 対応する_gpt_modelを探す
              const matchingModel = _gpt_model.find((gptModel) => gptModel.value === model.value)
              return {
                ...matchingModel, // _gpt_modelのすべてのプロパティをセット
                ...model, // Firebaseのモデルデータを上書き
                customDisplayName: model.customDisplayName || matchingModel.displayName // customDisplayNameが空の場合はdisplayNameをセット
              }
            })

          // _gpt_modelからFirebaseに存在しないモデルを探し、missingModelsとして補完
          const missingModels = _gpt_model
            .filter((gptModel) => !filteredModels.some((model) => model.value === gptModel.value)) // filteredModelsに存在しないモデル
            .map((gptModel) => ({
              active: true, // 足りないモデルはデフォルトでactiveに
              ...gptModel, // _gpt_modelのすべてのプロパティをコピー
              customDisplayName: gptModel.displayName // customDisplayNameにはdisplayNameを使用
            }))

          let updatedModels = [...filteredModels, ...missingModels].filter((model) => model.active)
          updatedModels = updatedModels.sort((a, b) => {
            const indexA = _gpt_model.findIndex((gptModel) => gptModel.value === a.value)
            const indexB = _gpt_model.findIndex((gptModel) => gptModel.value === b.value)
            return indexA - indexB
          })
          setConstantData((prevState) => ({
            ...prevState,
            _gpt_model: updatedModels
          }))
        }
        await getModelSettings()
      } catch (error) {
        console.error('Error fetching system settings:', error)
      }
    }
    fetchSystemSettings()
  }, [])

  useEffect(() => {
    if (selectedPrompt && selectedPrompt.model) {
      // constantData._gpt_model から value が一致するオブジェクトがあるか確認
      const matchingModel = constantData._gpt_model.find((model) => model.value === selectedPrompt.model)

      // マッチするモデルがない場合、_gpt_modelから新しいモデルを探して追加
      if (!matchingModel) {
        const newModel = _gpt_model.find((gptModel) => gptModel.value === selectedPrompt.model)

        // マッチする新しいモデルが存在する場合、constantData に追加
        if (newModel) {
          setConstantData((prevState) => ({
            ...prevState,
            _gpt_model: [
              ...prevState._gpt_model,
              {
                ...newModel,
                customDisplayName: newModel.displayName // displayNameをcustomDisplayNameとして使用
              }
            ]
          }))
        } else {
          console.warn(`モデルが見つかりませんでした: ${selectedPrompt.model}`)
        }
      }
    }
  }, [selectedPrompt])
  // console.log('constantData', constantData._gpt_model)

  const getSchoolsInfo = async (paramSchoolId) => {
    const getSchools = httpsCallable(functions, 'get_schools_info')
    const res = await getSchools(paramSchoolId) // schoolAIのschook情報を全件取得用
    const { data } = res
    // console.log('★★', data)
    return data
  }
  const signInWithUid = async (uid) => {
    const signIn = httpsCallable(functions, 'sign_in_with_uid')
    try {
      const res = await signIn({ uid })
      const { customToken } = res.data
      const userCredential = await signInWithCustomToken(auth, customToken)
      updateDoc(doc(db, 'users', userCredential.user.uid), {
        userId: userCredential.user.uid,
        email: userCredential.user.email ?? '',
        createdAt: userCredential.user.metadata.createdAt ?? null,
        lastLoginAt: userCredential.user.metadata.lastLoginAt ?? null
      })
    } catch (e) {
      navigate('/login')
    } finally {
    }
  }

  const onChangeFolder = (modes, folders, folder) => {
    if (!Array.isArray(modes)) return
    setFilteredModes(modes)
    if (!modes.length) {
      showCreateMode()
      return
    }

    if (isSameFolder(folder, prevFolderRef)) {
      // フォルダが同じままの場合
      const index = modes.findIndex((mode) => mode.id === selectedPrompt.id)
      if (index < 0) {
        selectExistingMode(modes)
      } else {
        // 変更されたモードが存在する → 何もせず選択のプロンプトを維持
      }
    } else {
      // フォルダが変わった場合（or 初期読み込み）
      selectNewMode(modes)
    }

    function isSameFolder(folder, prevFolderRef) {
      return folder && prevFolderRef.current && folder.uid === prevFolderRef.current.uid
    }

    function showCreateMode() {
      setFilteredModes(modes)
      setSelectedPrompt(initialPromptState)
      setSelectedItem(null)
      setAddBody(true)
      setPromptTitle('新規')
      setIsEdited(false)
    }
    function selectExistingMode(modes) {
      const mode = modes[0]
      setSelectedPrompt({ ...mode, ...additionalData })
      setSelectedItem(mode.id ?? '')
      setPromptTitle(mode.prompt_title ?? '')
      setAddBody(false)
      setIsEdited(false)
    }
    function selectNewMode(modes) {
      let mode = null
      const selectedPrompt = getSelectedPromptInLocalStorage()
      if (!selectedPrompt) {
        mode = modes[0]
      } else {
        const _mode = modes.find((_) => _.id === selectedPrompt.id)
        mode = _mode ? _mode : modes[0]
      }
      setSelectedPrompt({ ...mode, ...additionalData })
      setSelectedItem(mode.id)
      setSelectedPromptInLocalStorage(mode)
      setPromptTitle(mode.prompt_title)
      setAddBody(false)
      setIsEdited(false)
    }
  }

  const setFolderInLocalStorage = (folder) => {
    if (!folder) return
    localStorage.setItem('folder', JSON.stringify(folder))
  }

  const getFolderInLocalStorage = () => {
    const folder = localStorage.getItem('folder')
    return folder ? JSON.parse(folder) : null
  }

  const setSelectedPromptInLocalStorage = (prompt) => {
    if (!prompt) return
    localStorage.setItem('prompt', JSON.stringify(prompt))
  }

  const getSelectedPromptInLocalStorage = () => {
    const prompt = localStorage.getItem('prompt')
    return prompt ? JSON.parse(prompt) : null
  }

  /*****  useEffect *****/

  useEffect(() => {
    const _modes = folder ? [...folder.prompts] : []
    const _filteredModes = _modes.filter((mode) => mode.prompt_title.toLowerCase().includes(searchText.toLowerCase()))
    setFilteredModes(_filteredModes)
  }, [searchText])

  useEffect(() => {
    const _modes = folder ? [...folder.prompts] : []
    onChangeFolder(_modes, folders, folder)

    // フォルダの状況を監視
    prevFoldersRef.current = folders
    prevFolderRef.current = folder
    if (folder) {
      setFolderInLocalStorage(folder)
    }
  }, [folders, folder])

  const [parentSchools, setParentSchools] = useState([])
  const [classRoomData, setClassRoomData] = useState([])
  const [schoolName, setSchoolName] = useState()
  const fetchDocumentIds = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, '/externalServices/mingaku/schools'))
      const ids = querySnapshot.docs.map((doc) => doc.id)
      if (!!paramSchoolId) {
        const getSchoolInfoOfMingaku = httpsCallable(functions, 'get_school_info_of_mingaku')
        const schoolDataOfMingaku = await getSchoolInfoOfMingaku({ schoolId: paramSchoolId }) // schoolAIのschool情報を全件取得用
        const { data, configData } = schoolDataOfMingaku.data
        setIsPromptCreationForbidden(configData.isPromptCreationForbidden ?? false)

        // console.log('.data(自分のスクール)', schoolDataOfMingaku.data)
        const childrenSchoolIds = schoolDataOfMingaku.data.configData.childrenSchools.map(
          (school) => school.childSchoolDocId
        )

        const chilrenSchoolClassRoomData = schoolDataOfMingaku.data.configData.childrenSchools.map(
          (school) => school.classroomsData
        )
        const updatedChildrenSchoolClassRoomData = chilrenSchoolClassRoomData.map((schoolClassRooms, index) => {
          const schoolId = childrenSchoolIds[index] // 対応するschoolIdを取得

          // 各schoolClassRoomsのclassroomDataにschoolIdを追加
          return schoolClassRooms.map((classroom) => ({
            ...classroom,
            schoolId: schoolId
          }))
        })
        // console.log('子供スクールクラスルーム', updatedChildrenSchoolClassRoomData.flat())

        // タイトル用
        setSchoolName(schoolDataOfMingaku.data.data.name)
        //
        const updatedClassRoomData = schoolDataOfMingaku.data.classroomsData.map((classroom) => {
          return {
            ...classroom, // 既存のデータを展開
            schoolId: paramSchoolId // schoolIdを追加
          }
        })
        // console.log('自分のクラスルームデータ', [...updatedClassRoomData, ...updatedChildrenSchoolClassRoomData.flat()])

        // setClassRoomDataを呼び出して更新
        setClassRoomData([...updatedClassRoomData, ...updatedChildrenSchoolClassRoomData.flat()])
        // setClassRoomData(schoolDataOfMingaku.data.classroomsData && schoolDataOfMingaku.data.classroomsData)
        const { role = [], parentSchools = [], childrenSchools = [] } = configData
        setParentSchools(parentSchools)
        if (!!role) {
          setRoleInMingaku(role[0])
        }

        // getSchoolsInfoを十個???
        // console.log('学校取得時引数', paramSchoolId, schoolId)
        if (paramSchoolId) {
        }
        // const childrenSchoolIds = (childrenSchools || []).map((childrenSchool) => childrenSchool.childSchoolDocId)
        const schoolsToGetData = [...childrenSchoolIds, paramSchoolId]
        const { schoolInfo } = await getSchoolsInfo(paramSchoolId ? { schoolIds: [...schoolsToGetData] } : '') // schoolAIのschool情報を全件取得用
        // const { schoolInfo } = await getSchoolsInfo() // schoolAIのschool情報を全件取得用
        const schoolsOfSchoolAI = schoolInfo.filter((school) => !!school.data) // dataがないschoolは除外
        let schoolIdName = {} // schoolIdとschoolNameの対応表
        schoolsOfSchoolAI.map((school) => {
          return (schoolIdName[school.schoolId] = school.data.name) //
        })
        setSchoolIdName(schoolIdName)

        if (!!role && role[0] === 'serviceProvider') {
          // console.log('①role = serviceProvider')
          // const childrenSchoolIds = (childrenSchools || []).map((childrenSchool) => childrenSchool.childSchoolDocId)
          const commonSchoolIds = ids.filter((id) => childrenSchoolIds.includes(id))
          setDocumentIds(commonSchoolIds)
        } else {
          // console.log('①role = なし')

          setDocumentIds([])
        }
        return { role: role ? role[0] : '', parentSchools, childrenSchools }
      } else {
        // const childrenSchoolIds = (childrenSchools || []).map((childrenSchool) => childrenSchool.childSchoolDocId)
        const { schoolInfo } = await getSchoolsInfo() // schoolAIのschool情報を全件取得用
        const schoolsOfSchoolAI = schoolInfo.filter((school) => !!school.data) // dataがないschoolは除外
        let schoolIdName = {} // schoolIdとschoolNameの対応表
        schoolsOfSchoolAI.map((school) => {
          return (schoolIdName[school.schoolId] = school.data.name) //
        })
        // console.log('①schoolIdName', schoolIdName)
        setSchoolIdName(schoolIdName)
        setDocumentIds(ids)

        return { role: '', parentSchools: [], childrenSchools: [] }
      }
    } catch (error) {
      console.error('Error fetching document IDs:', error)
    }
  }

  const fetchDocumentIdsForStudent = async () => {
    // console.log('fetchDocumentIdsForStudent開始')
    setLoadingForStudentData(true) // ローディング開始
    try {
      // console.log('学校ID', documentIds, selectedIds)
      // 自分のスクールの生徒
      const usersCollectionRef = collection(db, 'users')
      const schoolUserQuery = query(usersCollectionRef, where('schoolDocId', '==', paramSchoolId))
      const mySchoolAllUserDocs = await getDocs(schoolUserQuery)

      const mySchoolUserDocs = mySchoolAllUserDocs.docs.filter((doc) => {
        const data = doc.data()
        // Base condition: user is not a tutor and has a valid schoolDocId matching paramSchoolId
        return data.role !== 'tutor'
      })

      let selectedSchoolIds
      let filteredUserDocs

      if (!paramSchoolId || roleInMingaku === 'serviceProvider') {
        // 子スクールがある学校
        selectedSchoolIds = selectedPrompt.availableAllSchools === true ? documentIds : selectedIds
        const childSchoolUserQuery = query(usersCollectionRef, where('schoolDocId', 'in', selectedSchoolIds))

        const userDocs = await getDocs(childSchoolUserQuery)

        // role フィールドが tutor でないユーザーをフィルタリング
        filteredUserDocs = userDocs.docs.filter((doc) => {
          const data = doc.data()
          return data.role !== 'tutor'
        })
      }

      // 生徒利用設定リストに表示する生徒
      let joinedUserDocs

      if (!paramSchoolId || roleInMingaku === 'serviceProvider') {
        joinedUserDocs = [...mySchoolUserDocs, ...filteredUserDocs]
      } else {
        joinedUserDocs = mySchoolUserDocs
      }

      const getStudentData = async (userinfo) => {
        try {
          if (!!userinfo.data().studentDocId) {
            // 生徒
            const getStudentInfo = httpsCallable(functions, 'get_student_info_of_mingaku')
            const getSchoolsInfo = httpsCallable(functions, 'get_schools_info')
            const [studentInfo, schoolInfo] = await Promise.all([
              getStudentInfo({ nandeUserId: userinfo.data().userId }),
              getSchoolsInfo({ schoolIds: [userinfo.data().schoolDocId] })
            ])
            const schoolId = schoolInfo.data.schoolInfo[0].data.id
            const studentId = studentInfo.data.data.id
            // Find the matching classroom object by classroomId
            const classroomObj = classRoomData.find(
              (classroom) => classroom.classroomId === studentInfo.data.data.classroomId
            )
            // 検索の仕方によっては空の場合'-'に変更したほうが良いかもしれない
            const classroomName = classroomObj ? classroomObj.classroomData.name : ''

            return {
              name: studentInfo.data.data.name,
              // grade: studentInfo.data.data.grade,
              loginId: `${schoolId}-${studentId}`, //みんがくスクールID
              schoolName: schoolInfo.data.schoolInfo[0].data.name || '-',
              id: userinfo.id, //firebase user ID,
              schoolId: schoolId,
              classRoom: classroomName, // Use the found classroom name
              classRoomId: studentInfo.data.data.classroomId,
              schoolAiSchoolId: userinfo.data().schoolDocId
            }
          }
        } catch (error) {
          console.error('Error fetching user data from Mingaku:', error)
          return null // エラー時には null を返す
        }
      }

      // console.log('①selectedClassRoomIds', selectedClassRoomIds)
      // filteredUserDocs のデータの分だけ getStudentData を実行し、その結果を配列で取得
      const studentDataArray = await Promise.all(joinedUserDocs.map((doc) => getStudentData(doc)))

      // null ではない結果のみを返す
      let validStudentDataArray = studentDataArray.filter((data) => data !== null)

      // 教室利用制限がかかっている場合、利用可能なクラスルームの生徒のみ残す
      if (selectedPrompt.availableAllClassRooms !== true) {
        validStudentDataArray = validStudentDataArray.filter((student) => {
          // If schoolAiSchoolId matches paramSchoolId, check if classRoomId is in selectedClassRoomIds
          // if (student.schoolAiSchoolId === paramSchoolId) {
          // console.log(student.classRoomId + 'の教室OK', student.name, student.classRoomId)

          return selectedClassRoomIds.includes(student.classRoomId)
          // }
          // // console.log('その他スクールOK ', student.name)
          // // If schoolAiSchoolId doesn't match paramSchoolId, leave the student in the array
          // return true
        })

        // console.log('Filtered validStudentDataArray', validStudentDataArray)
      }

      // console.log('②validStudentDataArray', validStudentDataArray)
      setDocumentIdsForStudent(validStudentDataArray)
    } catch (error) {
      setDocumentIdsForStudent([])
      console.error('Error in fetchDocumentIdsForStudent:', error)
    } finally {
      setLoadingForStudentData(false) // ローディング終了
    }
  }

  useEffect(() => {
    const newSelectedIds = selectedPrompt.selectedSchools ? selectedPrompt.selectedSchools : []

    setSelectedIds(newSelectedIds)
  }, [selectedPrompt.selectedSchools])

  useEffect(() => {
    const newViewableSelectedIds = selectedPrompt.viewableSelectedSchools ? selectedPrompt.viewableSelectedSchools : []

    setViewableSelectedIds(newViewableSelectedIds)
  }, [selectedPrompt.viewableSelectedSchools])

  useEffect(() => {
    const newSelectedIds = selectedPrompt.selectedStudents ? selectedPrompt.selectedStudents : []
    setSelectedStudentIds(newSelectedIds)
  }, [selectedPrompt.selectedStudents])
  useEffect(() => {
    const newSelectedIds = selectedPrompt.selectedClassRooms ? selectedPrompt.selectedClassRooms : []
    setClassRoomSelectedIds(newSelectedIds)
  }, [selectedPrompt.selectedClassRooms])

  useEffect(() => {
    if (!roleFromQueryParam || !muid) return
    auth.onAuthStateChanged(async (user) => {
      setLoading(true)
      const getAdminInfo = httpsCallable(functions, 'get_admin_info_of_mingaku')
      const { data } = await getAdminInfo({ userId: muid })
      const { adminAuthData, adminDocData } = data
      const email = data.adminAuthData.email
      const checkRegisteredEmail = httpsCallable(functions, 'check_regsitered_email')
      const res = await checkRegisteredEmail({ email })
      const emailRegisterd = res.data.exists
      const matchingUserDocRef = query(
        collection(db, 'users'),
        where('email', '==', email),
        where('type', '==', 'mingaku'),
        where('role', '==', 'admin')
      )
      const matchingDocSnapshot = await getDocs(matchingUserDocRef)
      const isAlreadyLinked = matchingDocSnapshot.docs.length !== 0
      const linkageData = {
        mingakuUserId: muid,
        type: 'mingaku',
        role: 'admin'
      }
      if (user) {
        if (!emailRegisterd) {
          setLoading(false)
          navigate('/signup_for_mingaku_tutor', {
            state: {
              redirectPath: `${path}`,
              email,
              adminAuthData,
              adminDocData,
              muid,
              role: roleFromQueryParam,
              linkageData
            }
          })
        } else {
          if (user.email === email) {
            const userDocRef = doc(db, 'users', user.uid)
            await setDoc(userDocRef, linkageData, { merge: true })
            setLoading(false)
          } else {
            setLoading(false)
            navigate('/login_for_mingaku_tutor', {
              state: {
                redirectPath: `${path}`,
                email,
                adminAuthData,
                adminDocData,
                muid,
                role: roleFromQueryParam,
                isAlreadyLinked,
                linkageData
              }
            })
          }
        }
      } else {
        if (!emailRegisterd) {
          setLoading(false)
          navigate('/signup_for_mingaku_tutor', {
            state: {
              redirectPath: `${path}`,
              email,
              adminAuthData,
              adminDocData,
              muid,
              role: roleFromQueryParam,
              linkageData
            }
          })
        } else {
          setLoading(false)
          navigate('/login_for_mingaku_tutor', {
            state: {
              redirectPath: `${path}`,
              email,
              adminAuthData,
              adminDocData,
              muid,
              role: roleFromQueryParam,
              isAlreadyLinked,
              linkageData
            }
          })
        }
      }
    })
  }, [muid, path, roleFromQueryParam])

  useEffect(() => {
    if (!schoolIdfromQueryParam || !muid) return
    auth.onAuthStateChanged(async (user) => {
      const getTutorInfo = httpsCallable(functions, 'get_tutor_info_of_mingaku')
      setLoading(true)
      const { data } = await getTutorInfo({ userId: muid, schoolId: schoolIdfromQueryParam })
      const { tutorAuthData, tutorDocData } = data
      const emailFromTutorAuthData = data.tutorAuthData.email
      const checkRegisteredEmail = httpsCallable(functions, 'check_regsitered_email')
      const res = await checkRegisteredEmail({ email: emailFromTutorAuthData })
      const emailRegisterd = res.data.exists
      const matchingUserDocRef = query(
        collection(db, 'users'),
        where('email', '==', emailFromTutorAuthData),
        where('schoolDocId', '==', schoolIdfromQueryParam),
        where('type', '==', 'mingaku'),
        where('role', '==', 'tutor')
      )
      const matchingDocSnapshot = await getDocs(matchingUserDocRef)
      const isAlreadyLinked = matchingDocSnapshot.docs.length !== 0
      const linkageData = {
        schoolDocId: schoolIdfromQueryParam,
        tutorDocId: muid,
        mingakuUserId: muid,
        type: 'mingaku',
        role: 'tutor'
      }
      if (user) {
        if (user.email !== emailFromTutorAuthData) {
          if (!emailRegisterd) {
            setLoading(false)
            navigate('/signup_for_mingaku_tutor', {
              state: {
                redirectPath: `${path}`,
                email: emailFromTutorAuthData,
                isAlreadyLinked,
                linkageData,
                tutorAuthData,
                tutorDocData,
                schoolIdfromQueryParam,
                muid,
                role: 'tutor'
              }
            })
          } else {
            setLoading(false)
            navigate('/login_for_mingaku_tutor', {
              state: {
                redirectPath: `${path}`,
                email: emailFromTutorAuthData,
                isAlreadyLinked,
                linkageData,
                tutorAuthData,
                tutorDocData,
                schoolIdfromQueryParam,
                muid,
                role: 'tutor'
              }
            })
          }
        } else {
          const userDocRef = doc(db, 'users', user.uid)
          await setDoc(userDocRef, linkageData, { merge: true })
          const schoolDocRef = doc(db, 'externalServices', 'mingaku', 'schools', schoolIdfromQueryParam)
          setDoc(schoolDocRef, { docId: schoolIdfromQueryParam }, { merge: true })
          const tutorDocRef = doc(schoolDocRef, 'tutors', muid)
          await setDoc(tutorDocRef, { ...data.tutorDocData }, { merge: true })
          setLoading(false)
          navigate(`/management?school_id=${schoolIdfromQueryParam}`)
        }
      } else {
        setLoading(false)
        if (!!uid) {
          ;(async () => {
            await signInWithUid(uid)
          })()
        } else {
          if (!emailRegisterd) {
            setLoading(false)
            navigate('/signup_for_mingaku_tutor', {
              state: {
                redirectPath: `${path}`,
                email: emailFromTutorAuthData,
                isAlreadyLinked,
                linkageData,
                tutorAuthData,
                tutorDocData,
                schoolIdfromQueryParam,
                muid,
                role: 'tutor'
              }
            })
          } else {
            setLoading(false)
            navigate('/login_for_mingaku_tutor', {
              state: {
                redirectPath: `${path}`,
                email: emailFromTutorAuthData,
                isAlreadyLinked,
                linkageData,
                tutorAuthData,
                tutorDocData,
                schoolIdfromQueryParam,
                muid,
                role: 'tutor'
              }
            })
          }
        }
      }
    })
  }, [muid, navigate, path, schoolIdfromQueryParam, signInWithUid, uid])

  useEffect(() => {
    ;(async () => {
      setLoading(true)
      try {
        const fetchDataPromises = []

        // Promptsすべて
        let promptDocRef
        let additionalPrompts = []
        // console.log('parentSchools実行')

        const { parentSchools } = await fetchDocumentIds()
        // console.log('parentSchools', parentSchools)
        if (paramSchoolId) {
          // console.log('①実行')
          const getSchools = httpsCallable(functions, 'get_schools_info')
          const res = await getSchools({ schoolIds: [paramSchoolId] }) // schoolAIのschook情報を全件取得用
          const { data } = res
          // console.log('①実行後data', data)

          const customPropertiesForInsertion = data.schoolInfo[0].customProperties.map((property) => ({
            id: property.id,
            title: property.title,
            key: property.title
          }))
          setStudentInfoItemsForInsertion([...customPropertiesForInsertion, ..._inserted_default_target_student_info])
          const mingakuDocRef = doc(db, 'externalServices', 'mingaku')
          const schoolsCollectionRef = collection(mingakuDocRef, 'schools')
          promptDocRef = doc(schoolsCollectionRef, paramSchoolId)
          // ①　全データの中で、selectedSchools登録されており、その中でdoc.id===schoolIdがあるモードを取得
          const selectedSchoolsQuery = query(collectionGroup(db, 'selectedSchools'), where('id', '==', paramSchoolId))
          fetchDataPromises.push(
            getDocs(selectedSchoolsQuery).then((snapshot) => {
              const selectedPrompts = snapshot.docs.map(async (doc) => {
                const promptRef = doc.ref.parent.parent
                const parentSchoolId = promptRef.parent.parent.id
                const promptSnapshot = await getDoc(promptRef)
                const promptData = promptSnapshot.data() // データ取得
                if (promptData) {
                  return {
                    ...promptData,
                    responseOptions:
                      promptData.responseOptions.length > 0 ? promptData.responseOptions : _responseOptions,
                    id: promptSnapshot.id,
                    // 編集不可
                    editable: false,
                    // selectedSchoolsにあるactiveフィールド
                    active: doc.data().active,
                    // 親スクールのID
                    parentSchoolId: parentSchoolId
                  }
                } else {
                  // // console.log('promptプロパティが存在しません。')
                  return
                }
              })
              return Promise.all(selectedPrompts)
            })
          )

          // ②　adminのpromptの中でselectedSchoolsがないモード(全スクール公開)を取得
          const gptPromptDocRef = doc(db, 'service_type', 'gpt-teacher')
          const promptsCollectionRef = collection(gptPromptDocRef, 'prompts')
          const allPromptsQuery = query(promptsCollectionRef)

          fetchDataPromises.push(
            getDocs(allPromptsQuery).then((snapshot) => {
              const allPrompts = snapshot.docs.map(async (doc) => {
                const prompt = doc.data()
                if (prompt.availableAllSchools === true) {
                  return {
                    ...prompt,
                    id: doc.id,
                    editable: false,
                    active: true,
                    parentSchoolId: 'gpt-teacher'
                  }
                } else if (!prompt.hasOwnProperty('availableAllSchools')) {
                  const selectedSchoolsRef = collection(doc.ref, 'selectedSchools')
                  const selectedSchoolsSnapshot = await getDocs(selectedSchoolsRef)
                  // availableAllSchoolsフィールドがなく、selectedSchoolsコレクションもないprompt→以前の実装事情によりこれもavailableAllとする
                  if (selectedSchoolsSnapshot.docs.length === 0) {
                    return {
                      ...prompt,
                      id: doc.id,
                      editable: false,
                      active: true,
                      parentSchoolId: 'gpt-teacher'
                    }
                  }
                }
                return null
              })
              return Promise.all(allPrompts)
            })
          )

          // ③親スクールの中で全共有のモードを取得
          if (parentSchools && parentSchools.length > 0) {
            setIsChildSchool(true)
            parentSchools.forEach((parentSchool) => {
              const parentPromptDocRef = doc(schoolsCollectionRef, parentSchool.schoolDocId)
              const _promptsCollectionRef = collection(parentPromptDocRef, 'prompts')
              const _allPromptsQuery = query(_promptsCollectionRef)
              fetchDataPromises.push(
                getDocs(_allPromptsQuery).then((snapshot) => {
                  const _allPrompts = snapshot.docs.map(async (doc) => {
                    const prompt = doc.data()
                    if (prompt.availableAllSchools === true) {
                      return {
                        ...prompt,
                        id: doc.id,
                        editable: false,
                        active: true,
                        parentSchoolId: parentSchool.schoolDocId
                      }
                    } else if (!prompt.hasOwnProperty('availableAllSchools')) {
                      const selectedSchoolsRef = collection(doc.ref, 'selectedSchools')
                      const selectedSchoolsSnapshot = await getDocs(selectedSchoolsRef)
                      // availableAllSchoolsフィールドがなく、selectedSchoolsコレクションもないprompt→以前の実装事情によりこれもavailableAllとする
                      if (selectedSchoolsSnapshot.docs.length === 0) {
                        return {
                          ...prompt,
                          id: doc.id,
                          editable: false,
                          active: true,
                          parentSchoolId: parentSchool.schoolDocId
                        }
                      }
                    }

                    return null
                  })
                  return Promise.all(_allPrompts)
                })
              )
            })
          }

          const [selectedSchoolsPrompts, allPrompts, ...parentPrompts] = await Promise.all(fetchDataPromises)
          // console.log('②selectedSchoolsPrompts', selectedSchoolsPrompts)

          additionalPrompts = selectedSchoolsPrompts.filter((prompt) => prompt !== null)
          additionalPrompts = additionalPrompts.concat(allPrompts.filter((prompt) => prompt !== null))
          // console.log('②additionalPrompts.concat', additionalPrompts)

          parentPrompts.forEach((prompts) => {
            additionalPrompts = additionalPrompts.concat(prompts.filter((prompt) => prompt !== null))
          })
          additionalPrompts = additionalPrompts.filter((prompt) => prompt && prompt.enable === true)
          // console.log('②additionalPrompts.filter', additionalPrompts)

          // viewableAllSchools===falseのものに関しては別途、閲覧制御するためデータを修正する
          const filteredPrompts = additionalPrompts.filter((prompt) => prompt && prompt.viewableAllSchools === false)
          // console.log('③filteredPrompts.', filteredPrompts)

          const nonViewableAllPrompts = await Promise.all(
            filteredPrompts.map(async (prompt) => {
              const selectedSchoolsRef = collection(prompt.ref, 'viewableSelectedSchools')
              const selectedSchoolsSnapshot = await getDocs(selectedSchoolsRef)
              // 表示可能なSchoolIdだけある
              let hidden
              if (selectedSchoolsSnapshot.docs.length === 0) {
                hidden = true
              } else {
                hidden = selectedSchoolsSnapshot.docs.every((doc) => {
                  if (doc.id === schoolIdfromQueryParam) {
                    return false
                  } else {
                    return true
                  }
                })
              }

              if (hidden) {
                return { ...prompt, hidden: true }
              } else if (!hidden) {
                return prompt
              }
            })
          )
          // additionalPromptsをviewableAllSchools!==false(全スクール閲覧可能)のものだけにする
          additionalPrompts = additionalPrompts.filter((prompt) => prompt && prompt.viewableAllSchools !== false)
          // additionalPromptsをnonViewableAllPromptsと結合
          additionalPrompts = additionalPrompts.concat(nonViewableAllPrompts)
          // console.log('④additionalPrompts', additionalPrompts)
        } else {
          promptDocRef = doc(db, 'service_type', serviceType)
        }

        // あとは自分の塾のpromptsとカテゴリを取得
        const prompts_q = query(collection(promptDocRef, 'prompts'))
        const categories_q = query(collection(promptDocRef, 'categories'))
        const [promptSnapshot, categoriesSnapshot] = await Promise.all([getDocs(prompts_q), getDocs(categories_q)])
        // console.log('④promptSnapshot.docs.length:', promptSnapshot.docs.length)
        let prompts = promptSnapshot.docs.map((doc) => {
          const matchingLanguage = getMatchingLanguage(doc.data().prompt_language2)
          return {
            isCreatedBySelf: true,
            prompt_title: doc.data().prompt_title ? doc.data().prompt_title : '',
            prompt_description: doc.data().prompt_description ? doc.data().prompt_description : '',
            prompt_language: doc.data().prompt_language ? doc.data().prompt_language : '',
            prompt_language2: matchingLanguage ? JSON.stringify(matchingLanguage) : '',
            prompt_type: doc.data().prompt_type ? doc.data().prompt_type : '',
            prompt_order: doc.data().prompt_order !== undefined ? doc.data().prompt_order : 0,
            time_window_limit: doc.data().time_window_limit !== undefined ? doc.data().time_window_limit : false,
            time_window: doc.data().time_window !== undefined ? doc.data().time_window : [],
            character_limit: doc.data().character_limit !== undefined ? doc.data().character_limit : false,
            maximum_character_count:
              doc.data().maximum_character_count !== undefined ? doc.data().maximum_character_count : 0,
            character_limit_per_month:
              doc.data().character_limit_per_month !== undefined ? doc.data().character_limit_per_month : false,
            maximum_character_count_per_month:
              doc.data().maximum_character_count_per_month !== undefined
                ? doc.data().maximum_character_count_per_month
                : 0,
            sending_count_limit: doc.data().sending_count_limit !== undefined ? doc.data().sending_count_limit : false,
            maximum_sending_count_limit:
              doc.data().maximum_sending_count_limit !== undefined ? doc.data().maximum_sending_count_limit : 0,
            is_past_message_limit_count_set:
              doc.data().is_past_message_limit_count_set !== undefined
                ? doc.data().is_past_message_limit_count_set
                : false,
            maximum_past_message_limit_count:
              doc.data().maximum_past_message_limit_count !== undefined
                ? doc.data().maximum_past_message_limit_count
                : 0,
            prompt: doc.data().prompt,
            enable: doc.data().enable,
            id: doc.id,
            ref: doc.ref,
            updatedAt: doc.data().updatedAt ? doc.data().updatedAt : '',
            responseOptions:
              doc.data().responseOptions && doc.data().responseOptions.length > 0
                ? doc.data().responseOptions
                : _responseOptions,
            iconImageUrl: doc.data().iconImageUrl ? doc.data().iconImageUrl : '',
            iconImagePath: doc.data().iconImagePath ? doc.data().iconImagePath : '',
            iconImageUrl2: doc.data().iconImageUrl2 ? doc.data().iconImageUrl2 : '',
            iconImagePath2: doc.data().iconImagePath2 ? doc.data().iconImagePath2 : '',
            autoSending: doc.data().autoSending === undefined ? defaultAutoSending : doc.data().autoSending,
            defaultMute: doc.data().defaultMute === undefined ? defaultDefaultMute : doc.data().defaultMute,
            temperature: doc.data().temperature !== undefined ? doc.data().temperature : 1,
            speakingRate: doc.data().speakingRate ? doc.data().speakingRate : '',
            model: doc.data().model === 'gpt-4' ? 'gpt-4-1106-preview' : doc.data().model,
            largeIcon: doc.data().largeIcon ?? false,
            displayInputContents: doc.data().displayInputContents ?? true,
            expandInputContents: doc.data().expandInputContents ?? false,
            formQuestions: doc.data().formQuestions ? doc.data().formQuestions : [],
            useAssistantApi: doc.data().useAssistantApi ?? false,
            assistantId: doc.data().assistantId ? doc.data().assistantId : '',
            availableAllSchools: doc.data().availableAllSchools ?? false,
            availableAllClassRooms: doc.data().availableAllClassRooms ?? true,
            viewableAllSchools: doc.data().viewableAllSchools ?? true,
            availableAllStudents: doc.data().availableAllStudents ?? true,
            categoryUid: doc.data().categoryUid ?? '',
            hidden: doc.data().canViewContent === false ? true : false,
            // 編集可能
            editable: true,
            modeColor: doc.data().modeColor ?? '',
            customGuide: doc.data().customGuide ?? null,
            links: doc.data().links ? doc.data().links.sort((a, b) => a.order - b.order) : [],
            useDisplayMessage: doc.data().useDisplayMessage ?? false,
            isAvailableWhenDisabled: doc.data().isAvailableWhenDisabled ?? false
          }
        })
        // console.log('ログ0 prompts', prompts)
        prompts = prompts.concat(additionalPrompts)
        if (prompts.length !== 0) {
          const results = prompts.sort(function (a, b) {
            return a.updatedAt > b.updatedAt ? -1 : 1
          })

          let additionalData = {}
          let assistantApiFiles
          if (results[0].assistantId) {
            const assistantId = results[0].assistantId
            try {
              const myAssistantAndFiles = await retrieveAssistant(assistantId)
              // console.log('myAssistantAndFiles', myAssistantAndFiles)
              const instructions = myAssistantAndFiles.assistant.instructions
              const files = myAssistantAndFiles.files.map((file) => ({ id: file.id, name: file.filename }))
              additionalData.assistantApiInstruction = instructions ?? ''
              assistantApiFiles = files
            } catch (e) {
              console.error(e)
              const additionalData = {
                assistantId: '',
                assistantApiInstruction: '',
                assistantApiFiles: [],
                useAssistantApi: false,
                deletedAssistantApi: true
              }
              results[0] = {
                ...results[0],
                ...additionalData
              }
              updateDoc(results[0].ref, {
                ...results[0],
                ...additionalData
              })
            }
          }
          const selectedSchoolsRef = collection(results[0].ref, 'selectedSchools')
          const selectedSchoolsSnapshot = await getDocs(selectedSchoolsRef)
          additionalData.selectedSchools = selectedSchoolsSnapshot.docs.map((doc) => doc.id)

          const viewableSelectedSchoolsRef = collection(results[0].ref, 'viewableSelectedSchools')
          const viewableSelectedSchoolsSnapshot = await getDocs(viewableSelectedSchoolsRef)
          additionalData.viewableSelectedSchools = viewableSelectedSchoolsSnapshot.docs.map((doc) => doc.id)

          const SelectedClassRoomsRef = collection(results[0].ref, 'selectedClassRooms')
          const SelectedClassRoomsSnapshot = await getDocs(SelectedClassRoomsRef)
          additionalData.selectedClassRooms = SelectedClassRoomsSnapshot.docs.map((doc) => doc.id)

          const SelectedStudentsRef = collection(results[0].ref, 'selectedStudents')
          const SelectedStudentsSnapshot = await getDocs(SelectedStudentsRef)
          additionalData.selectedStudents = SelectedStudentsSnapshot.docs.map((doc) => doc.id)
          setAdditionalData(additionalData)
          setSelectedStudentIds(additionalData.selectedStudents)
          setSelectedAssistantApiFiles(assistantApiFiles)
          setUpdatedAssistantFiles(assistantApiFiles)
          setIsEdited(false)
          setSelectedItem(results[0].id)
          setPromptTitle(results[0].prompt_title)
          setSelectedLanguage2(results[0].prompt_language2)

          const uniqueResults = results.filter(
            (result, index, self) => index === self.findIndex((r) => r.ref.path === result.ref.path)
          )
          // console.log('ログ0 setPrompt', uniqueResults)
          setPrompts(uniqueResults)

          const categories = categoriesSnapshot.empty
            ? []
            : categoriesSnapshot.docs.map((doc) => {
                const data = doc.data()
                return {
                  name: data.name ?? '',
                  type: data.type ?? '',
                  createdAt: data.createdAt ?? null,
                  description: data.description ?? '',
                  uid: data.uid ?? null
                }
              })
          setCategories(categories)
        } else {
          setAddBody(true)
          setPromptTitle('新規')
          setIsEdited(false)
        }
        setLoading(false)
      } catch (error) {
        console.error('Error fetching data:', error)
        setLoading(false)
      }
    })()
  }, [defaultAutoSending, defaultDefaultMute, paramSchoolId, schoolIdfromQueryParam, serviceType])

  useEffect(() => {
    setSelectedLanguage2(selectedPrompt.prompt_language2)
  }, [selectedPrompt])

  const checkModeIdInUrl = (filteredFolders) => {
    if (!filteredFolders || !filteredFolders.length) return
    const searchParams = new URLSearchParams(window.location.search)
    const param = 'mode_id'
    if (!searchParams.has(param)) return

    const cleanUp = () => {
      searchParams.delete(param)
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`
      window.history.replaceState(null, '', newUrl)
    }

    const uid = searchParams.get(param) ?? ''
    if (!uid) return cleanUp()

    const _folder = filteredFolders.find((folder) => folder.prompts.some((p) => p.id === uid))
    if (!_folder) return cleanUp()

    const _mode = _folder.prompts.find((p) => p.id === uid)
    if (!_mode) return cleanUp()

    setFolderInLocalStorage(_folder)
    setSelectedPromptInLocalStorage(_mode)

    cleanUp()
  }

  useEffect(() => {
    ;(async () => {
      const existingFolderDefinitions = !isAdmin ? [...categories] : []
      const folderDefinitions = [...existingFolderDefinitions, ...c_data.defaultFolderDefinitions]
      const _folders = folderDefinitions.map((def) => ({ ...def, prompts: [] }))

      if (isAdmin) {
        const adminFolder = _folders.find((_) => _.type === 'admin')
        if (adminFolder) adminFolder.prompts = [...prompts]
      } else {
        const parentIds = parentSchools.map((s) => s.schoolDocId)
        prompts.forEach((prompt) => {
          const folderType = (() => {
            if (prompt.parentSchoolId === 'gpt-teacher') return 'adminFolder'
            if (parentIds.some((_) => _ === prompt.parentSchoolId)) return 'parentFolder'
            if (existingFolderDefinitions.some((_) => _.uid === prompt.categoryUid)) return 'selfFolder'
            return 'tempFolder'
          })()

          switch (folderType) {
            case 'adminFolder':
              const adminFolder = _folders.find((_) => _.type === 'admin')
              if (adminFolder) adminFolder.prompts.push(prompt)
              break

            case 'parentFolder':
              const parentFolder = _folders.find((_) => _.type === 'parent')
              if (parentFolder) parentFolder.prompts.push(prompt)
              break

            case 'selfFolder':
              const uniqueFolder = _folders.find((_) => _.type === 'self' && _.uid === prompt.categoryUid)
              if (uniqueFolder) uniqueFolder.prompts.push(prompt)
              break

            case 'tempFolder':
              const tempFolder = _folders.find((_) => _.type === 'self' && _.isTempFolder)
              if (tempFolder) tempFolder.prompts.push(prompt)
              break

            default:
              break
          }
        })
      }
      const filteredFolders = isAdmin
        ? _folders.filter((folder) => folder.type === 'admin')
        : _folders
            .filter((folder) => {
              if (folder.type === 'self' && folder.isTempFolder && folder.prompts && folder.prompts.length > 0)
                return true
              if (folder.type === 'self' && !folder.isTempFolder) return true
              if (folder.type !== 'self' && folder.prompts && folder.prompts.length > 0) return true
              return false
            })
            .sort((a, b) => {
              /* 
              順番
              typeがselfで、isTempFolderがtrueなら最優先
              typeがselfで、isTempFolderがfalseやundefinedなら、nameでソート
              parentはselfよりも下にするが、adminよりは上に
              adminを最下部に
              それ以外（もしあれば）特に変更しない
              */

              if (a.type === 'self' && a.isTempFolder) return -1
              if (b.type === 'self' && b.isTempFolder) return 1

              if (a.type === 'self' && !a.isTempFolder && b.type === 'self' && !b.isTempFolder) {
                return a.name.localeCompare(b.name)
              }

              if (a.type === 'parent' && b.type === 'admin') return -1
              if (a.type === 'admin' && b.type === 'parent') return 1

              if (a.type === 'admin') return 1
              if (b.type === 'admin') return -1

              return 0
            })

      filteredFolders.forEach((folder) => {
        if (!folder.prompts) return
        if (!folder.prompts.length) return
        folder.prompts.sort((a, b) => a.prompt_order - b.prompt_order)
      })
      setFolders(filteredFolders)
      checkModeIdInUrl(filteredFolders)
      setFolder((prev) => {
        const _folder = getFolderInLocalStorage()
        if (!prev && !_folder) {
          return filteredFolders[0] || null
        }
        const _prev = prev ? { ...prev } : { ..._folder }
        const index = filteredFolders.findIndex((_) => _.uid === _prev?.uid)
        return index > 0 ? filteredFolders[index] : filteredFolders[0]
      })
    })()
  }, [prompts, categories])

  /******* 更新用ハンドラ ********/

  const handleInputPromptChange = (updates) => {
    setSelectedPrompt((prevData) => ({
      ...prevData,
      ...updates
    }))
  }

  const handleFolderEdition = (folder) => {
    if (!folder) return
    console.log()
    if (folder.type !== 'self') {
      alert('編集する権限がありません。')
      setFolderEditScreenShown(false)
      setFolderToEdit(null)
      return
    }
    setFolderEditScreenShown(true)
    setFolderToEdit(folder)
  }

  const closeModalAndChangeFormQuestions = (template, index) => {
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          return {
            ...formQuestion,
            options: JSON.parse(template).selectOptions
          }
        } else {
          return formQuestion
        }
      })
    })
    setModalOpen(false)
    setModalIndex()
  }
  // モーダルを開く関数
  const openModal = (index) => {
    setModalOpen(true)
    setModalIndex(index)
  }

  // モーダルを閉じる関数
  const closeModal = () => {
    setModalOpen(false)
    setModalIndex()
  }

  // プロンプトに質問IDを入れる
  const handleInsertClick = (questionKey, additionalText) => {
    // <a>要素がクリックされたときに呼ばれるハンドラ
    const textArea = textAreaRef.current
    const startPos = textArea.selectionStart // カーソルの開始位置を取得
    const endPos = textArea.selectionEnd // カーソルの終了位置を取得
    const currentText = textArea.value
    let newText

    // カーソルの位置に<a>のquestion.keyを挿入
    if (additionalText) {
      newText =
        currentText.substring(0, startPos) + '{' + questionKey + '}' + additionalText + currentText.substring(endPos)
    } else {
      newText = currentText.substring(0, startPos) + '{' + questionKey + '}' + currentText.substring(endPos)
    }

    // テキストエリアと状態を更新
    textArea.value = newText
    textArea.selectionStart = startPos + questionKey.length + 2
    textArea.selectionEnd = startPos + questionKey.length + 2
    handleInputPromptChange({ prompt: newText })
  }

  const updatePromptModel = (value) => {
    const modelInfo = constantData._gpt_model.find((item) => item.value === value)
    if (modelInfo && modelInfo.availableAssistApi === false) {
      handleInputPromptChange({ model: value, useAssistantApi: false })
      setSelectedAssistantApiFiles([])
    } else {
      handleInputPromptChange({ model: value })
    }
  }

  const updatePromptSpeakingRate = (value) => {
    const floatValue = parseFloat(value)

    if (!isNaN(floatValue) && floatValue >= 0.25 && floatValue <= 4.0) {
      handleInputPromptChange({ speakingRate: value })
    } else {
      alert('入力値は0.25から4.0の範囲内である必要があります。')
    }
  }
  const updatePromptTemperature = (value) => {
    const floatValue = parseFloat(value)

    if (!isNaN(floatValue) && floatValue >= 0 && floatValue <= 2.0) {
      handleInputPromptChange({ temperature: floatValue })
    } else {
      alert('入力値は0から2.0の範囲内である必要があります。')
    }
  }

  const updatePromptOrder = (value) => {
    const isValidInteger = /^\d*$/.test(value)
    if (!isValidInteger) {
      alert('半角数字で入力してください')
    } else {
      handleInputPromptChange({ prompt_order: Number(value) })
    }
  }

  const updatePromptFolder = (folderUid) => {
    if (['adminFolder', 'parentFolder'].includes(folderUid)) {
      alert('編集できないフォルダが選択されています')
      return
    }

    handleInputPromptChange({ categoryUid: folderUid === 'tempFolder' ? '' : folderUid })
  }

  const updatePromptFormQuestionCharacterLimit = (value, index) => {
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          return {
            ...formQuestion,
            answerCharacterLimit: !value,
            answerMaxLength: 0
          }
        } else {
          return formQuestion
        }
      })
    })
  }
  const updatePromptFormQuestionMandatory = (value, index) => {
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          return {
            ...formQuestion,
            mandatory: !value
          }
        } else {
          return formQuestion
        }
      })
    })
  }
  const updatePromptFormQuestionChangeable = (value, index) => {
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          return {
            ...formQuestion,
            changeable: !value
          }
        } else {
          return formQuestion
        }
      })
    })
  }

  const updateActive = async (e, id, item) => {
    e.stopPropagation()

    if (id === selectedPrompt.id) {
      handleInputPromptChange({
        enable: !selectedPrompt.enable
      })
    }
    // if editable==falseならitem.idのselectedSchoolsコレクションのschoolParamドキュメントのactiveフィールドを更新
    setPrompts(
      prompts.map((i) => {
        if (i.id === id) {
          return {
            ...i,
            enable: !i.enable
          }
        } else {
          return {
            ...i
          }
        }
      })
    )

    prompts.forEach(async (i) => {
      if (i.id === id) {
        // 管理者編集　selectedSchoolsがundefinedの場合、フィールドを削除または別の値に設定
        const updatedItem = {
          ...i,
          enable: !i.enable,
          updatedAt: new Date().getTime()
          // 管理者編集　selectedSchoolsがundefinedでなければその値を使用し、そうでなければnullまたは空の配列を設定
          // selectedSchools: i.selectedSchools ? [...i.selectedSchools] : null // または []
        }
        const { selectedSchools, viewableSelectedSchools, ...newUpdatedItem } = updatedItem
        await updateDoc(i.ref, newUpdatedItem)
      }
    })
    setIsEdited(false)
  }

  const updateActiveForTeacher = async (e, item) => {
    // 関数内でのイベント伝播を防ぐ
    e.stopPropagation()

    // selectedSchoolsコレクションの参照を取得（適切なFirebaseの参照を設定してください）
    const collectionRef = collection(item.ref, 'selectedSchools')
    const selectedSchoolsRef = doc(collectionRef, paramSchoolId)
    const docSnap = await getDoc(selectedSchoolsRef)
    // selectedSchoolsドキュメントを更新
    if (docSnap.exists()) {
      await updateDoc(selectedSchoolsRef, {
        active: !item.active,
        updatedAt: new Date().getTime()
      })
    } else {
      await setDoc(selectedSchoolsRef, {
        active: !item.active,
        updatedAt: new Date().getTime(),
        id: paramSchoolId
      })
    }

    // ローカルのstateも更新
    setPrompts(
      prompts.map((i) => {
        if (i.id === item.id && item.editable === false) {
          return {
            ...i,
            active: !i.active
          }
        } else {
          return i
        }
      })
    )
  }

  const addToDeleteArray = async (i) => {
    handleInputPromptChange({
      responseOptions: selectedPrompt.responseOptions.filter((_, index) => index !== i)
    })
  }

  const removeLink = (i) => {
    handleInputPromptChange({
      links: selectedPrompt.links.filter((_, index) => index !== i)
    })
  }

  const handleImage = (event) => {
    const image = event.target.files[0]
    setImageUrl(window.URL.createObjectURL(image))
    setImage(image)
  }
  const handleImage2 = (event) => {
    const image = event.target.files[0]
    setImageUrl2(window.URL.createObjectURL(image))
    setImage2(image)
  }
  const [updatedAssistantFiles, setUpdatedAssistantFiles] = useState([])
  const [assistantFileChanged, setAssistantFileChanged] = useState(false)
  const handleDeleteFile = (file, index) => {
    setAssistantFileChanged(true)
    // 選択されたインデックスのファイルを除外して新しい配列を作成
    if (updatedAssistantFiles !== undefined) {
      const newAssistantApiFiles = updatedAssistantFiles.filter((_, i) => i !== index)
      setUpdatedAssistantFiles(newAssistantApiFiles) // 状態を更新
    }
  }

  const handleAssistantApiFileUpload = (event) => {
    const assistantApiFiles = event.target.files
    // ファイルが20個を超える場合にconfirmダイアログを表示
    if (assistantApiFiles.length > 20) {
      const isConfirmed = window.confirm(
        '選択されたファイルが20個を超えています。最初の20個のファイルのみを処理しますか？'
      )
      if (!isConfirmed) {
        // ユーザーがキャンセルを選択した場合、ここで処理を停止
        return
      }
    }
    setAssistantFileChanged(true)
    const filesToProcess = Array.from(assistantApiFiles).slice(0, 20)
    const assistantApiFilesInfo = filesToProcess.map((file) => ({
      name: file.name,
      // object_url: window.URL.createObjectURL(file),
      id: '',
      file: file
    }))
    // UI上のFile配列
    if (updatedAssistantFiles === undefined) {
      setUpdatedAssistantFiles(assistantApiFilesInfo)
    } else {
      setUpdatedAssistantFiles((prevFiles) => [...prevFiles, ...assistantApiFilesInfo])
    }
  }
  const deleteImage = async () => {
    setImage('')
    setImageUrl('')
    handleInputPromptChange({
      iconImageUrl: ''
    })
  }

  const deleteImage2 = async () => {
    setImage2('')
    setImageUrl2('')
    handleInputPromptChange({
      iconImageUrl2: ''
    })
  }

  const addToAddArray = () => {
    const addEmpyOption = { order: selectedPrompt.responseOptions.length + 1, option: '', content: '' }
    handleInputPromptChange({
      responseOptions: [...selectedPrompt.responseOptions, addEmpyOption]
    })
  }

  const addNewLinkSpot = () => {
    const emptyOption = { order: selectedPrompt.links.length + 1, name: '', uri: '' }
    handleInputPromptChange({
      links: [...selectedPrompt.links, emptyOption]
    })
  }

  const addFormQuestionFields = () => {
    const addEmptyQuestion = {
      order: selectedPrompt.formQuestions.length + 1,
      title: '',
      type: 'text',
      key: `input${selectedPrompt.formQuestions.length + 1}`,
      options: []
    }
    handleInputPromptChange({
      formQuestions: [...selectedPrompt.formQuestions, addEmptyQuestion]
    })
  }

  const addToDeleteQuestionArray = async (i) => {
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.filter((_, index) => index !== i)
    })
  }

  const handleQuestionTypeChange = (value, index) => {
    if (value === 'pulldown') {
      handleInputPromptChange({
        formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
          if (i === index) {
            return {
              ...formQuestion,
              type: value,
              options: [{ order: 1, displayName: '', value: '' }]
            }
          } else {
            return formQuestion
          }
        })
      })
    } else if (value === 'text' || value === 'image') {
      // テキストに変更された場合は、選択用のoptionsは不要なのでを初期値に戻す
      handleInputPromptChange({
        formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
          if (i === index) {
            return {
              ...formQuestion,
              type: value,
              options: [],
              mandatory: value === 'image' ? true : formQuestion.mandatory
            }
          } else {
            return formQuestion
          }
        })
      })
    }

    setPulldownTemplate(JSON.stringify(_pulldownTemplates[0]))
  }
  const handleQuestionKeyChange = (value, index) => {
    if (/[^a-zA-Z0-9_]/.test(value)) {
      alert('半角英数字以外の文字は入力できません。')
      return // 非半角英数字が入力された場合、処理を中断
    }
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          return {
            ...formQuestion,
            key: value
          }
        } else {
          return formQuestion
        }
      })
    })
  }

  const handleQuestionOrderChange = (value, index) => {
    if (isNaN(value)) {
      alert('数字を入力してください')
      return
    }
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          return {
            ...formQuestion,
            order: value && Number(value)
          }
        } else {
          return formQuestion
        }
      })
    })
  }

  const handleQuestionTitleChange = (value, index) => {
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          return {
            ...formQuestion,
            title: value
          }
        } else {
          return formQuestion
        }
      })
    })
  }
  const handleQuestionDescriptionChange = (value, index) => {
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          return {
            ...formQuestion,
            description: value
          }
        } else {
          return formQuestion
        }
      })
    })
  }

  const addToDeleteFormQuestionOptionsArray = async (index, o_index) => {
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          if (formQuestion.options.length === 1) {
            alert('最低１つの選択肢が必要です')
            return formQuestion // 選択肢が1つしかない場合、変更を行わずに元のフォーム質問を返す
          } else {
            return {
              ...formQuestion,
              options: formQuestion.options.filter((_, index) => index !== o_index)
            }
          }
        } else {
          return formQuestion
        }
      })
    })
  }

  const addFormQuestionOptionsFields = (index) => {
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          return {
            ...formQuestion,
            options: [
              ...formQuestion.options,
              {
                order: formQuestion.options.length + 1,
                displayName: '',
                value: ''
              }
            ]
          }
        } else {
          return formQuestion
        }
      })
    })
  }

  const handleFormQuestionsOptionsOrderChange = (value, index, o_index) => {
    if (value && isNaN(value)) {
      alert('数字を入力してください')
      return
    }

    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          const updatedOptions = formQuestion.options.map((option, o_i) => {
            if (o_i === o_index) {
              return {
                ...option,
                order: Number(value) // 新しい値に変更
              }
            }
            return option
          })

          return {
            ...formQuestion,
            options: updatedOptions
          }
        } else {
          return formQuestion
        }
      })
    })
  }

  const handleFormQuestionsOptionsDisplayNameChange = (value, index, o_index) => {
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          const updatedOptions = formQuestion.options.map((option, o_i) => {
            if (o_i === o_index) {
              return {
                ...option,
                displayName: value // 新しい値に変更
              }
            }
            return option
          })

          return {
            ...formQuestion,
            options: updatedOptions
          }
        } else {
          return formQuestion
        }
      })
    })
  }

  const handleFormQuestionsOptionsValueChange = (value, index, o_index) => {
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          const updatedOptions = formQuestion.options.map((option, o_i) => {
            if (o_i === o_index) {
              return {
                ...option,
                value: value // 新しい値に変更
              }
            }
            return option
          })
          return {
            ...formQuestion,
            options: updatedOptions
          }
        } else {
          return formQuestion
        }
      })
    })
  }
  const handleFormQuestionAnswerMaxLengthChange = (value, index) => {
    if (/[^a-zA-Z0-9_]/.test(value)) {
      alert('半角英数字以外の文字は入力できません。')
      return // 非半角英数字が入力された場合、処理を中断
    }
    handleInputPromptChange({
      formQuestions: selectedPrompt.formQuestions.map((formQuestion, i) => {
        if (i === index) {
          return {
            ...formQuestion,
            answerMaxLength: value
          }
        } else {
          return formQuestion
        }
      })
    })
  }
  const handleOptionOrderChange = (value, index) => {
    if (isNaN(value)) {
      alert('数字を入力してください')
      return
    }
    handleInputPromptChange({
      responseOptions: selectedPrompt.responseOptions.map((responseOption, i) => {
        if (i === index) {
          return { order: value && Number(value), option: responseOption.option, content: responseOption.content }
        } else {
          return responseOption
        }
      })
    })
  }

  const handleOptionChange = (value, index) => {
    handleInputPromptChange({
      responseOptions: selectedPrompt.responseOptions.map((responseOption, i) => {
        if (i === index) {
          return { order: Number(responseOption.order), option: value, content: responseOption.content }
        } else {
          return responseOption
        }
      })
    })
  }

  const handleOptionContentChange = (value, index) => {
    handleInputPromptChange({
      responseOptions: selectedPrompt.responseOptions.map((responseOption, i) => {
        if (i === index) {
          return { order: Number(responseOption.order), option: responseOption.option, content: value }
        } else {
          return responseOption
        }
      })
    })
  }

  const handleLinkChange = (value, index, type) => {
    if (!type) return
    if (!['order', 'name', 'uri'].includes(type)) return
    if (type === 'order' && (isNaN(value) || Number.isNaN(+index))) {
      alert('数字を入力してください')
      return
    }
    const _value = type === 'order' ? +value : value
    handleInputPromptChange({
      links: selectedPrompt.links.map((link, i) => (i === index ? { ...link, [type]: _value } : link))
    })
  }

  // スクール選択 - フィルター済データ
  // let filteredIds
  const [filteredIds, setFilteredIds] = useState([])
  useEffect(() => {
    const _filteredIds = documentIds.filter((id) => {
      if (schoolIdName[id]) {
        return schoolIdName[id].includes(searchQuery)
      } else {
        return false
      }
    })
    setFilteredIds(_filteredIds)
  }, [schoolIdName, documentIds, searchQuery])

  // スクール選択 - 選択
  const handleCheckboxChange = (event) => {
    const id = event.target.value
    const isChecked = event.target.checked

    setSelectedIds((prevSelectedIds) => {
      // 新しい選択状態のIDリストを作成
      const newSelectedIds = isChecked
        ? [...prevSelectedIds, id]
        : prevSelectedIds.filter((selectedId) => selectedId !== id)

      // selectedPromptのselectedSchoolsを更新
      handleInputPromptChange({ selectedSchools: newSelectedIds })
      return newSelectedIds
    })

    if (!isChecked) {
      setViewableSelectedIds((prevViewableSelectedIds) => {
        // inputViewableSelectedIdsから指定されたidを削除
        const newViewableSelectedIds = prevViewableSelectedIds.filter((selectedId) => selectedId !== id)
        return newViewableSelectedIds
      })
    }
  }

  // スクール選択 - 表示されている学校を全選択
  const handleSelectAll = () => {
    setSelectedIds(filteredIds)
    handleInputPromptChange({ selectedSchools: filteredIds })
  }
  // スクール選択 - 表示されている学校を全削除
  const handleDeselectAll = () => {
    setSelectedIds([])
    handleInputPromptChange({ selectedSchools: [] })
  }

  // スクール選択 - 全選択
  const handleInputAvailableAllSchoolsChange = (value) => {
    handleInputPromptChange({
      availableAllSchools: !value,
      selectedSchools: []
    })
    const filteredIds = viewableSelectedIds.filter((id) => selectedIds.includes(id))
    setViewableSelectedIds(filteredIds)

    if (!value === true) {
      setSelectedIds([])
    }
  }

  // スクール詳細閲覧選択 - フィルター済データ
  let _filteredIds = documentIds.filter((id) => {
    if (schoolIdName[id]) {
      return schoolIdName[id].includes(inputSearchQuery)
    } else {
      return false
    }
  })
  // スクール詳細閲覧選択 - 全選択
  const handleInputViewableAllSchoolsChange = (value) => {
    handleInputPromptChange({
      viewableAllSchools: !value,
      viewableSelectedSchools: []
    })
    if (!value === true) {
      setViewableSelectedIds([])
    }
  }

  // スクール詳細閲覧選択 - 表示されている学校を全選択
  const handleViewableSelectAll = () => {
    setViewableSelectedIds(_filteredIds)
    setSelectedPrompt({ ...selectedPrompt, viewableSelectedSchools: filteredIds })
  }

  // スクール詳細閲覧選択 - 全削除
  const handleViewableDeselectAll = () => {
    setViewableSelectedIds([])
    setSelectedPrompt({ ...selectedPrompt, viewableSelectedSchools: [] })
  }
  // スクール詳細閲覧選択 - 選択
  const handleViewableCheckboxChange = (event) => {
    const id = event.target.value
    const isChecked = event.target.checked
    setViewableSelectedIds((prevSelectedIds) => {
      // 新しい選択状態のIDリストを作成
      const newSelectedIds = isChecked
        ? [...prevSelectedIds, id]
        : prevSelectedIds.filter((selectedId) => selectedId !== id)
      setSelectedPrompt({ ...selectedPrompt, viewableSelectedSchools: newSelectedIds })
      return newSelectedIds
    })
  }

  // 生徒選択 - フィルター済みデータ
  let filteredIdsForStudent = documentIdsForStudent.filter((student) => {
    const matchesSchoolName = searchQueries.schoolName ? student.schoolName.includes(searchQueries.schoolName) : true
    const matchesStudentName = searchQueries.studentName ? student.name.includes(searchQueries.studentName) : true
    const matchesStudentId = searchQueries.loginId ? student.loginId.includes(searchQueries.loginId) : true
    const matchesClassRoom = searchQueries.classRoom ? student.classRoom.includes(searchQueries.classRoom) : true
    return matchesSchoolName && matchesStudentName && matchesStudentId && matchesClassRoom
  })

  // 生徒選択　- 全選択
  const handleInputAvailableAllStudentsChange = (value) => {
    handleInputPromptChange({
      availableAllStudents: !value,
      selectedStudents: []
    })
    if (!value === true) {
      setSelectedStudentIds([])
    }
  }

  // 生徒選択 - 選択
  const handleStudentCheckboxChange = (event) => {
    const id = event.target.value
    const isChecked = event.target.checked

    setSelectedStudentIds((prevSelectedIds) => {
      // 新しい選択状態のIDリストを作成
      const newSelectedIds = isChecked
        ? [...prevSelectedIds, id]
        : prevSelectedIds.filter((selectedId) => selectedId !== id)

      // selectedPromptのselectedSchoolsを更新
      handleInputPromptChange({ selectedStudents: newSelectedIds })
      return newSelectedIds
    })
  }
  // 生徒選択 - 表示されている生徒を全選択
  const handleSelectAllStudent = () => {
    const studentIds = filteredIdsForStudent.map((student) => student.id)
    setSelectedStudentIds(studentIds)
    handleInputPromptChange({ selectedStudents: studentIds })
  }

  // 生徒選択 - 表示されている生徒を全削除
  const handleDeselectAllStudent = () => {
    setSelectedStudentIds([])
    handleInputPromptChange({ selectedStudents: [] })
  }

  // 教室選択 - フィルター済みデータ
  let filteredClassRoomIds = classRoomData.filter((classRoom) => {
    const matchesClassRoom = searchQueryOfClassRoom
      ? classRoom.classroomData.name.includes(searchQueryOfClassRoom)
      : true

    return matchesClassRoom
  })
  // 教室選択 - 全選択
  const handleInputAvailableAllClassRoomChange = (value) => {
    handleInputPromptChange({
      availableAllClassRooms: !value,
      selectedClassRooms: []
    })
    // const filteredIds = viewableSelectedIds.filter((id) => selectedIds.includes(id))
    // setViewableSelectedIds(filteredIds)

    if (!value === true) {
      setClassRoomSelectedIds([])
    }
  }
  // 教室選択 - 選択
  const handleClassRoomCheckboxChange = (event) => {
    const id = event.target.value
    const isChecked = event.target.checked

    setClassRoomSelectedIds((prevSelectedIds) => {
      // 新しい選択状態のIDリストを作成
      const newSelectedIds = isChecked
        ? [...prevSelectedIds, id]
        : prevSelectedIds.filter((selectedId) => selectedId !== id)

      // selectedPromptのselectedSchoolsを更新
      handleInputPromptChange({ selectedClassRooms: newSelectedIds })
      return newSelectedIds
    })
  }
  // 教室選択 - 表示されている教室の全選択
  const handleSelectAllClassRoom = () => {
    const classRoomIds = filteredClassRoomIds.map((classRoom) => classRoom.classroomId)
    setClassRoomSelectedIds(classRoomIds)
    handleInputPromptChange({ selectedClassRooms: classRoomIds })
  }

  // 教室選択 - 表示されている教室の全解除
  const handleDeselectAllClassRoom = () => {
    setClassRoomSelectedIds([])
    handleInputPromptChange({ selectedClassRooms: [] })
  }
  const [filteredViewableIds, setFilteredViewableIds] = useState([])

  useEffect(() => {
    let newFilteredViewableIds
    if (selectedPrompt.availableAllSchools) {
      newFilteredViewableIds = documentIds.filter((id) => {
        if (schoolIdName[id]) {
          return schoolIdName[id].includes(viewableSearchQuery)
        } else {
          return false
        }
      })
    } else {
      newFilteredViewableIds = selectedIds.filter((id) => {
        if (schoolIdName[id]) {
          return schoolIdName[id].includes(viewableSearchQuery)
        } else {
          return false
        }
      })
    }
    setFilteredViewableIds(newFilteredViewableIds)
  }, [
    selectedPrompt.availableAllSchools,
    selectedPrompt.selectedSchools,
    viewableSearchQuery,
    documentIds,
    selectedIds,
    schoolIdName
  ])

  useEffect(() => {
    if (selectedPrompt.availableAllClassRooms) {
      return
    } else {
      // console.log('filteredIdsForStudent', filteredIdsForStudent)
      filteredIdsForStudent = filteredIdsForStudent.filter((student) => {
        const { classRoomId } = student

        // Keep if classRoomId is empty, or if it's included in selectedClassRoomIds
        return !classRoomId || selectedClassRoomIds.includes(classRoomId)
      })
    }
    // console.log('newFilteredClassRoomIds', filteredIdsForStudent)
  }, [selectedPrompt.availableAllClassRooms, selectedPrompt.selectedClassRooms])

  const handleCopy = () => {
    setIsCopied(true)
    // 2秒後にコピー成功のメッセージを非表示にする
    setTimeout(() => {
      setIsCopied(false)
    }, 2000)
  }

  const handleCopyModeLink = (item) => {
    let link
    if (item.editable) {
      link = `${linkToCopy}&common=false&showheader=false&showfooter=false&ref=${item.ref.path}`
    } else {
      link = `${linkToCopy}&common=true&showheader=false&showfooter=false&ref=${item.ref.path}`
    }
    navigator.clipboard
      .writeText(link)
      .then(() => {
        alert('モード開始リンクがクリップボードにコピーされました！')
      })
      .catch((err) => {
        console.error('リンクのコピーに失敗しました: ', err)
      })
  }
  const handleCopyModeShareLink = (item, options = { canViewContent: true }) => {
    let link
    const { canViewContent } = options
    if (item.editable) {
      link = `${linkForReproduction}&common=false&showheader=false${
        !canViewContent ? '&canViewContent=false' : ''
      }&ref=${item.ref.path}&uidFrom=${auth.currentUser.uid}`
    } else {
      link = `${linkForReproduction}&common=true&showheader=false${
        !canViewContent ? '&canViewContent=false' : ''
      }&ref=${item.ref.path}&uidFrom=${auth.currentUser.uid}`
    }
    navigator.clipboard
      .writeText(link)
      .then(() => {
        alert('共有リンクがクリップボードにコピーされました！')
      })
      .catch((err) => {
        console.error('リンクのコピーに失敗しました: ', err)
      })
  }

  const handleModeStart = (item) => {
    const url = `/redirect?mode=${item.ref.id}&common=${
      item.common ? item.common.toString() : 'false'
    }&showheader=true&time_window=false&ref=${item.ref.path}`
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const awaitBodySwitched = async () => {
    return new Promise((resolve) => {
      const timer = setInterval(() => {
        if (!isSwitchingBody) {
          clearInterval(timer)
          resolve()
        }
      }, 100)
    })
  }

  /* モード選択・新規作成時に画面が切り替わるときのハンドラ */
  const switchBody = async (item) => {
    if (isSwitchingBody) await awaitBodySwitched()

    setIsSwitchingBody(true)
    // console.log(item.availableAllSchools)
    if (
      isEdited === true &&
      !window.confirm(
        '変更がまだ保存されていないようですが、よろしいですか？\n保存しないと、変更内容は消えてしまいます。'
      )
    ) {
      return
    }
    setFolderEditScreenShown(false)
    if (managementModuleRef.current) {
      managementModuleRef.current.scrollTop = 0
    }
    let additionalData = {}
    const selectedSchoolsRef = collection(item.ref, 'selectedSchools')
    const selectedSchoolsSnapshot = await getDocs(selectedSchoolsRef)
    additionalData.selectedSchools = selectedSchoolsSnapshot.docs.map((doc) => doc.id)
    const viewableSelectedSchoolsRef = collection(item.ref, 'viewableSelectedSchools')
    const viewableSelectedSchoolsSnapshot = await getDocs(viewableSelectedSchoolsRef)
    additionalData.viewableSelectedSchools = viewableSelectedSchoolsSnapshot.docs.map((doc) => doc.id)
    const SelectedClassRoomsRef = collection(item.ref, 'selectedClassRooms')
    const SelectedClassRoomsSnapshot = await getDocs(SelectedClassRoomsRef)
    additionalData.selectedClassRooms = SelectedClassRoomsSnapshot.docs.map((doc) => doc.id)
    const SelectedStudentsRef = collection(item.ref, 'selectedStudents')
    const SelectedStudentsSnapshot = await getDocs(SelectedStudentsRef)
    additionalData.selectedStudents = SelectedStudentsSnapshot.docs.map((doc) => doc.id)
    // AssisntantAPIの情報の取得に時間がかかるため、AssisntantAPIの情報の取得する前にselectedPromptをsetしておく。これによりモード切り替え時のラグを軽減
    let newItem = {
      ...item,
      ...additionalData
    }
    setSelectedItem(item.id)
    setSelectedPrompt({
      ...item,
      ...additionalData
    })

    // ここでAssistantAPIの情報を取得して、selectedPromptに追加する
    let assistantApiFiles
    if (item.assistantId && item.assistantId !== '') {
      try {
        const myAssistantAndFiles = await retrieveAssistant(item.assistantId)
        // console.log('myAssistantAndFiles', myAssistantAndFiles)
        // console.log('myAssistantAndFiles', myAssistantAndFiles)
        const instructions = myAssistantAndFiles.assistant.instructions
        const files = myAssistantAndFiles.files.map((file) => ({ id: file.id, name: file.filename }))
        additionalData.assistantApiInstruction = instructions ?? ''
        assistantApiFiles = files
      } catch (e) {
        console.error(e)
        additionalData.assistantApiFiles = []
        additionalData.assistantApiInstruction = ''
        additionalData.assistantId = ''
        additionalData.useAssistantApi = false
        additionalData.deletedAssistantApi = true
        updateDoc(item.ref, {
          ...newItem,
          ...additionalData
        })
      }
    }
    newItem = {
      ...newItem,
      ...additionalData
    }
    setSelectedItem(item.id)
    setSelectedPrompt(newItem)
    setPromptTitle(item.prompt_title)
    setSelectedPromptInLocalStorage(newItem)
    setAddBody(false)
    setPulldownTemplate(JSON.stringify(_pulldownTemplates[0]))
    setInputSearchQuery('')
    setSelectedAssistantApiFiles(assistantApiFiles)
    setUpdatedAssistantFiles(assistantApiFiles)
    setIsEdited(false)
    setIsSwitchingBody(false)
  }
  const changeFolder = async (folder) => {
    if (isSwitchingBody) await awaitBodySwitched()

    if (
      isEdited === true &&
      !window.confirm(
        '変更がまだ保存されていないようですが、よろしいですか？\n保存しないと、変更内容は消えてしまいます。'
      )
    ) {
      return
    }
    setFolderEditScreenShown(false)
    setFolder(folder)
  }
  const displayAddBody = () => {
    if (!folder) return
    if (!isAdmin && folder.type !== 'self') {
      alert('自身のスクールのフォルダを選択してください。')
      return
    }
    if (
      isEdited === true &&
      !window.confirm(
        '変更がまだ保存されていないようですが、よろしいですか？\n保存しないと、変更内容は消えてしまいます。'
      )
    ) {
      return
    }
    setFolderEditScreenShown(false)
    if (managementModuleRef.current) {
      managementModuleRef.current.scrollTop = 0
    }
    setSelectedAssistantApiFiles()
    setUpdatedAssistantFiles()
    setAddBody(true)
    setSelectedItem()
    setSelectedPrompt(initialPromptState)
    setPromptTitle('新規')
    setIsEdited(false)
  }
  const getAssistantApiFiles = async (assistant_id) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/open_ai_get_assistant_files'
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        assistant_id: assistant_id
      })
    })
    const data = await res.json()
    const assistantFiles = data.assistantFiles.data
    const file_data = await Promise.all(
      assistantFiles.map(async (file) => ({ id: file.id, name: (await getFileInfo(file.id)).filename }))
    )
    return file_data
  }
  const getFileInfo = async (fileId) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/get_file_info'
    const res = await fetch(URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ file_id: fileId })
    })
    const data = await res.json()
    return data.file
  }
  const isValidUri = (uri) => {
    const uriRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
    return uriRegex.test(uri)
  }
  const validatePromptData = (promptData) => {
    const selectedModel = _gpt_model.find((model) => model.value === promptData.model)
    const checks = [
      { condition: promptData.prompt_title === '', message: 'タイトルは必須入力です。\n' },
      { condition: promptData.prompt === '', message: 'プロンプトは必須入力です。\n' },
      {
        condition: promptData.responseOptions.some((response) => response.option === ''),
        message: '返答選択肢の選択肢名は必須入力です。\n'
      },
      { condition: promptData.links.some((link) => !link.name), message: 'リンクの表示名は必須入力です。\n' },
      {
        condition: promptData.links.some((link) => !isValidUri(link.uri)),
        message: '入力されたリンクの値に不正な値があります。\n'
      },
      {
        condition: promptData.formQuestions.some((question) => question.title === ''),
        message: 'フォームの各質問タイトルは必須入力です。\n'
      },
      {
        condition: promptData.formQuestions.some((question) => question.key === ''),
        message: 'フォームの質問の差し込みコードは必須入力です。\n'
      },
      {
        condition: promptData.formQuestions.some((question) => question.key === 'submission_data_for_analysis'),
        message: `システムの仕様により、フォームの質問の差し込みコードに'submission_data_for_analysis'は使えません。\n`
      },
      {
        condition:
          new Set(promptData.formQuestions.map((optionObj) => optionObj.key)).size !== promptData.formQuestions.length,
        message: 'フォームの質問の差し込みコードの値が被っています。一意になるように設定してください。\n'
      },
      {
        condition:
          new Set(promptData.formQuestions.map((question) => question.order)).size !== promptData.formQuestions.length,
        message: 'フォームの質問の順番は被らないように設定してください。\n'
      },
      {
        condition: promptData.formQuestions.some(
          (question) =>
            question.type === 'pulldown' && question.options.some((option) => option.displayName.trim() === '')
        ),
        message: 'フォームのプルダウンの選択肢名は必須入力です。\n'
      },
      {
        condition: promptData.formQuestions.some(
          (question) => question.type === 'text' && question.answerCharacterLimit && question.answerMaxLength <= 0
        ),
        message: 'フォームの質問の最大文字数を設定する場合は1以上にしてください。\n'
      },
      {
        condition: promptData.character_limit && promptData.maximum_character_count <= promptData.prompt.length,
        message: `文字数制限の最大文字数はプロンプトの文字数(${promptData.prompt.length}文字)より多くする必要があります。\n`
      },
      {
        condition:
          promptData.character_limit_per_month &&
          promptData.maximum_character_count_per_month <= promptData.prompt.length,
        message: `・1ヶ月あたりの文字数制限の最大文字数はプロンプトの文字数(${promptData.prompt.length}文字)より多くする必要があります。\n`
      },
      {
        condition: promptData.sending_count_limit && promptData.maximum_sending_count_limit <= 0,
        message: '・送信回数制限は1以上を設定してください。\n'
      },
      {
        condition: promptData.is_past_message_limit_count_set && promptData.maximum_past_message_limit_count <= 0,
        message: '・送信時に含める過去のメッセージ数制限は1以上を設定してください。\n'
      },
      {
        condition: promptData.useAssistantApi && promptData.assistantApiInstruction === '',
        message: '・アシスタントAPIの役割を設定してください。\n'
      },
      {
        condition: promptData.useAssistantApi && (!updatedAssistantFiles || updatedAssistantFiles.length === 0),
        message: '・アシスタントAPIのファイルは1つ以上設定してください。\n'
      },
      {
        condition:
          promptData.time_window_limit === true &&
          promptData.time_window.length > 0 &&
          promptData.time_window.some((window) => window.start >= window.end),
        message: '・時間ウィンドウの開始時間は終了時間より早くしてください。\n'
      },
      {
        condition:
          selectedModel &&
          !selectedModel.availableVision &&
          promptData.formQuestions.some((question) => question.type === 'image'),
        message: `・${selectedModel.displayName}モデルは画像対応しておりません。モデルを変更するか、画像タイプの質問を削除してください。\n`
      },
      {
        condition: promptData.useAssistantApi && promptData.formQuestions.some((question) => question.type === 'image'),
        message: `・アシスタントAPIを使用しているため画像対応できません。アシスタントAPIを無効にするか、画像タイプの質問を削除してください。\n`
      },
      {
        condition:
          prompts.length &&
          prompts
            .filter((p) => p.isCreatedBySelf)
            .filter((p) => p.id !== promptData.id)
            .some((p) => p.prompt_title === promptData.prompt_title),
        message: 'すでに使われているモード名です。'
      }
    ]

    return checks
      .filter((check) => check.condition)
      .map((check) => check.message)
      .join('')
  }

  const savePrompt = async (promptData) => {
    if (!isAuthorizedToCreatePrompt) {
      alert('プロンプトを編集する権限ありません。')
      return
    }
    setLoadingText('モードを保存中...')
    const alertMessage = validatePromptData(promptData)

    if (alertMessage !== '') {
      alert(alertMessage)
      return
    }
    if (!folder) {
      alert('フォルダが選択されていません。フォルダがない場合は作成してください。')
      return
    }
    if (!isAdmin && folder.type !== 'self') {
      alert('自身のスクールのフォルダを選択してください。')
      return
    }

    setLoading(true)
    let newDocRef
    if (addBody) {
      let uid = ''
      if (folder.isTempFolder || folder.type !== 'self') {
        //何もしない
      } else {
        uid = folder.uid
      }

      newDocRef = await addDoc(promptDocRefToUpdate, {
        ...promptData,
        createdAt: new Date().getTime(),
        updatedAt: new Date().getTime(),
        categoryUid: !isAdmin ? uid : null
      })
      await updateDoc(newDocRef, { ref: newDocRef })
      setSelectedPromptInLocalStorage({ ...promptData, id: newDocRef.id })
    } else {
      const { selectedSchools, viewableSelectedSchools, selectedStudents, selectedClassRooms, ...newItem } = promptData
      if (newItem.categoryUid.includes('Folder')) {
        newItem.categoryUid = ''
      }

      newItem.updatedAt = new Date().getTime()
      await updateDoc(promptData.ref, newItem)

      const { categoryUid = '' } = newItem
      let newFolder
      if (categoryUid) {
        newFolder = folders.find((folder) => folder.type === 'self' && folder.uid === categoryUid)
        if (newFolder) setFolderInLocalStorage(newFolder)
      }
      setSelectedPromptInLocalStorage(promptData)
      newDocRef = promptData.ref
    }

    // 利用可能スクールの登録・削除
    const selectedSchoolsRef = collection(newDocRef, 'selectedSchools')
    const currentSchoolsSnapshot = await getDocs(selectedSchoolsRef)
    const currentSchools = currentSchoolsSnapshot.docs.map((doc) => doc.id)

    const schoolsToDelete = currentSchools.filter((id) => !promptData.selectedSchools.includes(id))
    for (const id of schoolsToDelete) {
      const docRef = doc(selectedSchoolsRef, id)
      await deleteDoc(docRef)
    }
    if (promptData.selectedSchools !== undefined) {
      const filteredSelectedSchools = promptData.selectedSchools.filter((id) => schoolIdName[id])
      for (const id of filteredSelectedSchools) {
        if (!currentSchools.includes(id)) {
          const newDocRef = doc(selectedSchoolsRef, id)
          await setDoc(newDocRef, {
            active: true,
            id: id
          })
        }
      }
    }

    // 閲覧可能スクールの登録・削除
    const viewableSelectedSchoolsRef = collection(newDocRef, 'viewableSelectedSchools')
    const viewableCurrentSchoolsSnapshot = await getDocs(viewableSelectedSchoolsRef)
    const viewableCurrentSchools = viewableCurrentSchoolsSnapshot.docs.map((doc) => doc.id)

    const viewableSchoolsToDelete = viewableCurrentSchools.filter(
      (id) => !promptData.viewableSelectedSchools.includes(id)
    )
    for (const id of viewableSchoolsToDelete) {
      const docRef = doc(viewableSelectedSchoolsRef, id)
      await deleteDoc(docRef)
    }
    if (promptData.viewableSelectedSchools !== undefined) {
      const filteredViewableSelectedSchools = promptData.viewableSelectedSchools.filter((id) => schoolIdName[id])
      for (const id of filteredViewableSelectedSchools) {
        if (!viewableCurrentSchools.includes(id)) {
          const newDocRef = doc(viewableSelectedSchoolsRef, id)
          await setDoc(newDocRef, {
            active: true,
            id: id
          })
        }
      }
    }
    // 利用可能生徒の登録
    const selectedClassRoomsRef = collection(newDocRef, 'selectedClassRooms')
    const currentSelectedClassRoomsSnapshot = await getDocs(selectedClassRoomsRef)
    const currentSelectedClassRooms = currentSelectedClassRoomsSnapshot.docs.map((doc) => doc.id)
    // 不要な生徒を削除
    // const studentsToDelete = currentSelectedClassRooms.filter((id) => !promptData.selectedClassRooms.includes(id))
    const classroomsToDelete = currentSelectedClassRooms.filter(
      (id) => Array.isArray(promptData.selectedClassRooms) && !promptData.selectedClassRooms.includes(id)
    )

    for (const id of classroomsToDelete) {
      const docRef = doc(selectedClassRoomsRef, id)
      await deleteDoc(docRef)
    }
    // 選択された生徒を登録
    if (promptData.selectedClassRooms !== undefined) {
      // const filteredSelectedStudents = promptData.selectedClassRooms.filter((id) => id)
      for (const id of promptData.selectedClassRooms) {
        if (!currentSelectedClassRooms.includes(id)) {
          // console.log('教室登録実行')
          const newDocRef = doc(selectedClassRoomsRef, id)
          await setDoc(newDocRef, {
            active: true,
            id
          })
        }
      }
    }

    // 利用可能生徒の登録
    const selectedStudentsRef = collection(newDocRef, 'selectedStudents')
    const currentSelectedStudentsSnapshot = await getDocs(selectedStudentsRef)
    const currentSelectedStudents = currentSelectedStudentsSnapshot.docs.map((doc) => doc.id)
    // 不要な生徒を削除
    // const studentsToDelete = currentSelectedStudents.filter((id) => !promptData.selectedStudents.includes(id))
    const studentsToDelete = currentSelectedStudents.filter(
      (id) => Array.isArray(promptData.selectedStudents) && !promptData.selectedStudents.includes(id)
    )

    for (const id of studentsToDelete) {
      const docRef = doc(selectedStudentsRef, id)
      await deleteDoc(docRef)
    }
    // 選択された生徒を登録
    if (promptData.selectedStudents !== undefined) {
      // const filteredSelectedStudents = promptData.selectedStudents.filter((id) => id)
      for (const id of promptData.selectedStudents) {
        if (!currentSelectedStudents.includes(id)) {
          // console.log('生徒登録実行')
          const newDocRef = doc(selectedStudentsRef, id)
          await setDoc(newDocRef, {
            active: true,
            id
          })
        }
      }
    }

    // アイコン更新
    const imageArray = [image ? image : '', image2 ? image2 : '']
    await Promise.all(
      imageArray.map(async (image, index) => {
        if (image) {
          const iconImagePath = `promptIcons/${newDocRef.path}/${index + 1}_${image.name}`
          const storageRef = ref(storage, iconImagePath)
          try {
            // 既存の画像があればstorageに新しい画像追加する前に削除
            if (index === 0 && promptData.iconImagePath) {
              try {
                await deleteObject(ref(storage, promptData.iconImagePath))
              } catch (error) {
                console.error(`削除しようとした画像が存在しません。`)
              }
            } else if (index === 1 && promptData.iconImagePath2) {
              try {
                await deleteObject(ref(storage, promptData.iconImagePath2))
              } catch (error) {
                console.error(`削除しようとした画像が存在しません。`)
              }
            }
            // 画像をアップロードして、その結果を取得
            const uploadSnapshot = await uploadBytes(storageRef, image)
            // アップロード情報をオブジェクトに追加
            let imageInfo
            if (index === 0) {
              imageInfo = {
                iconImageUrl: await getDownloadURL(uploadSnapshot.ref),
                iconImagePath: uploadSnapshot.metadata.fullPath || '',
                updatedAt: new Date().getTime()
              }
            } else {
              imageInfo = {
                [`iconImageUrl${index + 1}`]: await getDownloadURL(uploadSnapshot.ref),
                [`iconImagePath${index + 1}`]: uploadSnapshot.metadata.fullPath || '',
                updatedAt: new Date().getTime()
              }
            }
            // Firestore ドキュメントを更新
            await updateDoc(newDocRef, imageInfo)
          } catch (error) {
            console.error(`画像${index + 1}のエラー:`, error)
          }
        }
      })
    )

    // アシスタントAPIの処理
    if (
      promptData.assistantId === '' &&
      promptData.assistantApiInstruction !== '' &&
      updatedAssistantFiles &&
      updatedAssistantFiles.length > 0 &&
      promptData.useAssistantApi === true
    ) {
      const addedFiles = updatedAssistantFiles
      const [file_ids, vectorStore] = await Promise.all([
        uploadSelectedFiles(addedFiles),
        createVectorStore(promptData.prompt_title)
      ])
      const vector_store_id = vectorStore.id
      const requestBodyForCreateAssistant = {
        model: 'gpt4o',
        name: promptData.prompt_title,
        instructions: promptData.assistantApiInstruction,
        tools: [{ type: 'file_search' }],
        tool_resources: {
          file_search: {
            vector_store_ids: [vector_store_id]
          }
        }
      }
      const [myVectorStoreFileBatch, myAssistant] = await Promise.all([
        createVectorStoreFileBatch({ vector_store_id: vectorStore.id, file_ids }),
        createAssistant(requestBodyForCreateAssistant)
      ])
      // console.log('file_ids', file_ids)
      // console.log('vectorStore', vectorStore)
      // console.log('myVectorStoreFileBatch', myVectorStoreFileBatch)
      // console.log('myAssistant', myAssistant)
      const assistantId = myAssistant.id
      await updateDoc(newDocRef, { assistantId, updatedAt: new Date().getTime() })
      setAssistantFileChanged(false)
    } else if (promptData.assistantId && promptData.assistantId !== '' && promptData.useAssistantApi === true) {
      if (updatedAssistantFiles !== undefined) {
        const addedFiles = updatedAssistantFiles.filter(
          (f2) => !(selectedAssistantApiFiles || []).some((f1) => f1.id === f2.id)
        )
        const deletedFiles = (selectedAssistantApiFiles || []).filter(
          (f1) => !(updatedAssistantFiles || []).some((f2) => f2.id === f1.id)
        )
        // console.log('addedFiles', addedFiles)
        // console.log('deletedFiles', deletedFiles)
        if (deletedFiles.length > 0) {
          await deleteFiles(deletedFiles, promptData.assistantId)
        }
        if (addedFiles.length > 0) {
          const myAssistant = await retrieveAssistant(promptData.assistantId)
          const vectorStoreId = myAssistant.assistant.tool_resources.file_search.vector_store_ids[0] // vectorStoreIdは1つしかない前提
          const file_ids = await uploadSelectedFiles(addedFiles)
          await createVectorStoreFileBatch({ vector_store_id: vectorStoreId, file_ids })
        }
        const requestBodyForModifyAssistant = {
          instructions: promptData.assistantApiInstruction,
          name: promptData.prompt_title,
          tools: [{ type: 'file_search' }],
          model: 'gpt4o'
        }
        await modifyAssistant(promptData.assistantId, requestBodyForModifyAssistant)
        // await uploadAllFiles(addedFiles, promptData.assistantId, null, promptData.ref) // 単一ファイルを配列に入れて渡す
      }
      setAssistantFileChanged(false)
    }
    setLoadingText('')
    setLoading(false)
    window.location.reload()
  }
  //////////////////////////////////////AssistantAPI関連の関数

  const retrieveAssistant = async (assistant_id) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_retrieve_assistant'
    const res = await fetch(URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ assistant_id })
    })
    const data = await res.json()
    const filesPromise = data.myAssistant.tool_resources.file_search.vector_store_ids.map((vector_store_id) => {
      return getVectorStoreFiles(vector_store_id)
    })
    const [files] = await Promise.all(filesPromise)
    return {
      assistant: data.myAssistant,
      files
    }
  }

  const deleteAssistant = async (assistant_id) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_delete_assistant'
    const res = await fetch(URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ assistant_id })
    })
    const data = await res.json()
    // console.log(data)
  }

  const getVectorStoreFiles = async (vector_store_id) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_get_vector_store_files'
    const res = await fetch(URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ vector_store_id })
    })
    const { files, error } = await res.json()
    // console.log(error)
    // console.log(files)
    return files
  }

  const createVectorStore = async (mode_name) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_create_vector_store'
    const res = await fetch(URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ mode_name })
    })
    const { vectorStore } = await res.json()
    // console.log(vectorStore)
    return vectorStore
  }

  const uploadSelectedFiles = async (selectedFiles) => {
    if (updatedAssistantFiles.length === 0) {
      alert('ファイルが選択されていません。')
      return []
    }
    const uploadPromises = selectedFiles.map(async (fileObject) => {
      // console.log('file', fileObject.file)
      return uploadFile(fileObject.file)
    })
    const uploadedFileIds = await Promise.all(uploadPromises)
    // console.log('uploadedFileIds', uploadedFileIds)
    setUpdatedAssistantFiles([])
    return uploadedFileIds
  }

  const uploadFile = async (selectedFile) => {
    if (!selectedFile) {
      alert('ファイルが選択されていません。')
      return
    }
    // console.log('selectedFile', selectedFile)
    const formData = new FormData()
    formData.append('file', selectedFile, encodeURIComponent(selectedFile.name))
    // console.log('formData', formData)
    try {
      const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_upload_file'
      const res = await fetch(URL, {
        method: 'POST',
        body: formData
      })
      const { response } = await res.json() // 追加: レスポンスのJSONを解析
      // console.log('response', response)
      const uploadedFileId = response.id
      return uploadedFileId
    } catch (error) {
      console.error('Error uploading file:', error)
      alert('ファイルのアップロード中にエラーが発生しました。')
    }
  }

  const createAssistant = async (body) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_create_assistant'
    const res = await fetch(URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
    const { myAssistant } = await res.json()
    // console.log(myAssistant)
    return myAssistant
  }

  const createVectorStoreFileBatch = async ({ vector_store_id, file_ids }) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_create_vector_store_file_batch'
    const res = await fetch(URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ vector_store_id, file_ids })
    })
    const { myVectorStoreFileBatch } = await res.json()
    // console.log(myVectorStoreFileBatch)
    return myVectorStoreFileBatch
  }

  const deleteAllFilesOfVectorStoreAndVectorStore = async (vector_store_id) => {
    const vectorStoreFiles = await getVectorStoreFiles(vector_store_id)
    // console.log('vectorStoreFiles', vectorStoreFiles)
    const deletePromises = vectorStoreFiles.map(async (file) => {
      // console.log('file', file)
      return deleteFile(file.id)
    })
    const deletedFiles = await Promise.all(deletePromises)
    // console.log('deletedFiles', deletedFiles)
    const deletedVectorStore = deleteVectorStore(vector_store_id)
    // console.log('deletedVectorStore', deletedVectorStore)
  }

  const deleteVectorStore = async (vector_store_id) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_delete_vector_store'
    const res = await fetch(URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ vector_store_id })
    })
    const data = await res.json()
    // console.log(data)
    return data
  }

  const deleteFiles = async (deletedFiles, assistantId) => {
    try {
      // 各ファイルIDに対してdeleteFileを並列実行
      const deletePromises = deletedFiles.map((file) => deleteFile(file.id))
      // すべての削除処理が完了するのを待つ
      await Promise.all(deletePromises)
      // console.log('All files deleted successfully')
    } catch (error) {
      console.error('Error deleting files:', error)
      alert('ファイルの削除中にエラーが発生しました。')
    }
  }

  const deleteFile = async (file_id) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_delete_file'
    const res = await fetch(URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ file_id })
    })
    const data = await res.json()
    // console.log(data)
    return data.file
  }

  const modifyAssistant = async (assistant_id, modifyContent) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_modify_assistant'
    const res = await fetch(URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ assistant_id, modifyContent })
    })
    const data = await res.json()
    // console.log(data)
    return data
  }
  //////////////////////////////////////

  // const deleteFiles = async (deletedFiles, assistantId) => {
  //   try {
  //     // 各ファイルIDに対してdeleteFileを並列実行
  //     const deletePromises = deletedFiles.map((file) => deleteFile(file.id, assistantId))
  //     // すべての削除処理が完了するのを待つ
  //     await Promise.all(deletePromises)
  //     // console.log('All files deleted successfully')
  //   } catch (error) {
  //     console.error('Error deleting files:', error)
  //     alert('ファイルの削除中にエラーが発生しました。')
  //   }
  // }

  // const deleteFile = async (fileId, assistantId) => {
  //   const URL1 = 'https://school-ai-r3y4on4j2a-an.a.run.app/delete_assistant_file' // AssisntantAPIからファイルを削除するAPI (物理削除ではない)
  //   await fetch(URL1, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify({ file_id: fileId, assistant_id: assistantId })
  //   })
  //   const URL2 = 'https://school-ai-r3y4on4j2a-an.a.run.app/delete_file' // ファイル自体を物理削除
  //   await fetch(URL2, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify({ file_id: fileId })
  //   })
  //   getAssistantApiFiles(selectedPrompt.assistantId) // ファイル一覧を再取得
  // }

  const uploadAllFiles = async (selectedFiles, assistant_id, requestBodyForCreate = null, newDocRef = null) => {
    try {
      // 各ファイルをアップロードし、それぞれのIDを取得する
      const uploadPromises = selectedFiles.map(async (fileObject) => {
        // handleUploadにfileプロパティを渡す
        const uploadedFileId = await handleUpload(fileObject.file)
        // アップロード後にIDを返す
        return uploadedFileId
      })
      // 全てのアップロードが完了するのを待つ
      const uploadedFileIds = await Promise.all(uploadPromises)

      if (assistant_id && assistant_id !== '') {
        const selectedIds = selectedAssistantApiFiles.map((file) => file.id)
        // 更新
        await updateAssistantAPIWithFileId(assistant_id, [...selectedIds, ...uploadedFileIds])
        await updateDoc(selectedPrompt.ref, {
          updatedAt: new Date().getTime()
        })
      } else {
        // console.log('新規アシスタントID作成')
        const _assistantId = await createAssistantAPIwithFileId(uploadedFileIds, requestBodyForCreate)
        await updateDoc(newDocRef, {
          assistantId: _assistantId,
          updatedAt: new Date().getTime()
        })
      }
    } catch (error) {
      console.error('Error uploading files:', error)
      alert('ファイルのアップロード中にエラーが発生しました。')
    }
  }

  const updateAssistantAPIWithFileId = async (assistantId, newFileIds) => {
    try {
      const modifyContent = {
        instructions: selectedPrompt.assistantApiInstruction,
        name: selectedPrompt.prompt_title,
        tools: [{ type: 'retrieval' }],
        model: selectedPrompt.model,
        file_ids: newFileIds // 新しいファイルIDの配列
      }
      const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/modify_assistant'
      const res = await fetch(URL, {
        method: 'POST', // 更新は通常PATCHまたはPUTメソッドを使用します。
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ assistant_id: assistantId, modifyContent })
      })
      const updatedAssistant = await res.json()
      // 必要に応じて、更新後のAssistant IDをセットするなどの処理を追加
      // setAssistantId(updatedAssistant.id);
    } catch (error) {
      console.error('updateAssistantAPI failed:', error)
    }
    // console.log('updateAssistantAPI終了')
  }

  const handleUpload = async (selectedFile) => {
    if (!selectedFile) {
      alert('ファイルが選択されていません。')
      return
    }
    // console.log('handleUpload: selectedFile', selectedFile)
    const formData = new FormData()
    formData.append('file', selectedFile, encodeURIComponent(selectedFile.name))
    try {
      // const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/upload_file_to_openai'
      const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/upload_file_to_openai'
      const res = await fetch(URL, {
        method: 'POST',
        body: formData
      })
      const { response } = await res.json() // 追加: レスポンスのJSONを解析
      const uploadedFileId = response.id
      // createAssistantAPIwithFileId(uploadedFileId)
      // setUploadedFile({ ...response })
      // alert('ファイルがアップロードされました。')
      // setSelectedFile(null) // ファイル選択状態のリセット
      // setFileName('') // ファイル名表示のリセット
      return uploadedFileId
    } catch (error) {
      console.error('Error uploading file:', error)
      alert('ファイルのアップロード中にエラーが発生しました。')
    }
  }

  const createAssistantAPIwithFileId = async (fileIds, requestBodyForCreate = null) => {
    try {
      let requestBody = {}
      if (!requestBodyForCreate) {
        requestBody = {
          name: selectedPrompt.prompt_title,
          description: selectedPrompt.prompt_description,
          instructions: selectedPrompt.assistantApiInstruction,
          tools: [{ type: 'retrieval' }],
          model: selectedPrompt.model,
          file_ids: fileIds // csvファイルは失敗するっぽい
        }
      } else {
        requestBody = { ...requestBodyForCreate, file_ids: fileIds }
      }
      const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/open_ai_create_assistant_api'
      const res = await fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ ...requestBody })
      })
      const { myAssistant } = await res.json() // 追加: レスポンスのJSONを解析
      return myAssistant.id
    } catch (error) {
      console.error('createAssistantAPI failed:', error)
    }
    // console.log('createAssistantAPI終了')
  }

  const [promptDocRefToUpdate, setPromptDodRefToUpdate] = useState()
  useEffect(() => {
    let ref
    if (paramSchoolId) {
      // paramSchoolIdがあれば塾用docrefをセット
      const mingakuDocRef = doc(db, 'externalServices', 'mingaku')
      ref = collection(mingakuDocRef, 'schools', paramSchoolId, 'prompts')
    } else {
      // paramSchoolIdがなければ通常サービスごとのdocrefをセット
      ref = collection(db, 'service_type', serviceType, 'prompts')
    }
    setPromptDodRefToUpdate(ref)
  }, [paramSchoolId])

  /* 複製ボタンのハンドラ */

  const determineFolder = (folderUid) => {
    let categoryUid = ''
    let _folder = null
    if (folderUid) {
      if (folderUid.includes('Folder')) {
        // イレギュラーパターン
        categoryUid = ''
        _folder = null
      } else {
        categoryUid = folderUid
        const _ = folders.find((_) => _.uid === folderUid)
        _folder = _ ? _ : null
      }
    } else {
      categoryUid = ''
      _folder = folder ? (folder.type === 'self' ? folder : null) : null
    }
    return [categoryUid, _folder]
  }

  const copyPrompt = async (e, item) => {
    if (!isAuthorizedToCreatePrompt) {
      alert('プロンプトを複製する権限ありません。')
      return
    }
    const alertMessage = validatePromptData(item)
    if (alertMessage !== '') {
      alert(alertMessage)
      return
    }

    const [categoryUid, _folder] = determineFolder(item.categoryUid)
    const data = {
      prompt_title: item.prompt_title + 'コピー',
      prompt_description: item.prompt_description,
      prompt_language2: item.prompt_language2,
      prompt_type: item.prompt_type,
      prompt_order: Number(item.prompt_order),
      prompt: item.prompt,
      character_limit: item.character_limit ? item.character_limit : false,
      categoryUid,
      maximum_character_count: item.maximum_character_count ? item.maximum_character_count : 0,
      character_limit_per_month: item.character_limit_per_month ? item.character_limit_per_month : false,
      maximum_character_count_per_month: item.maximum_character_count_per_month
        ? item.maximum_character_count_per_month
        : 0,
      sending_count_limit: item.sending_count_limit ? item.sending_count_limit : false,
      maximum_sending_count_limit: item.maximum_sending_count_limit ? item.maximum_sending_count_limit : 0,
      enable: false,
      responseOptions: item.responseOptions.filter((optionObj) => optionObj.option !== ''),
      formQuestions: item.formQuestions.filter((optionObj) => optionObj.title !== ''),
      autoSending: item.autoSending,
      defaultMute: item.defaultMute,
      temperature: Number.parseFloat(item.temperature),
      speakingRate: item.speakingRate,
      model: item.model,
      largeIcon: item.largeIcon ? item.largeIcon : false,
      displayInputContents: item.displayInputContents ? item.displayInputContents : true,
      expandInputContents: item.expandInputContents ? item.expandInputContents : false,
      createdAt: new Date().getTime(),
      updatedAt: new Date().getTime(),
      useDisplayMessage: item.useDisplayMessage ?? false,
      isAvailableWhenDisabled: item.isAvailableWhenDisabled ?? false
      // assistantAPI周りは複製なし
      // 利用・閲覧可能設定も複製なし
    }
    const newDocRef = await addDoc(promptDocRefToUpdate, data)
    await updateDoc(newDocRef, { ref: newDocRef })

    setSelectedPromptInLocalStorage({ ...data, id: newDocRef.id })
    setFolderInLocalStorage(_folder)
    window.location.reload()
  }

  const deletePrompt = async (ref) => {
    await deleteDoc(ref)
  }

  const cleanUpAssistant = async (assistantId) => {
    if (!assistantId) return
    const myAssistant = await retrieveAssistant(assistantId)
    const vectorStoreId = myAssistant.assistant.tool_resources.file_search.vector_store_ids[0] // 1つしかない前提
    await Promise.all([deleteAllFilesOfVectorStoreAndVectorStore(vectorStoreId), deleteAssistant(assistantId)])

    // const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/delete_assistant_and_assistant_files'
    // await fetch(URL, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({ assistant_id: assistantId })
    // })
    // console.log(`${assistantId}の削除完了`)
  }

  /* 削除ボタンのハンドラ */
  const deleteSelectedPrompt = async (id, _ref, imagePath, imagePath2) => {
    try {
      const docSnapshot = await getDoc(_ref)
      const data = docSnapshot.data()
      if (data.enable === true) {
        alert(
          '現在使用されており削除できません。\n削除するにはプロンプトのチェックボックスの✓を外して、アクティブ状態をオフにしてください。'
        )
      } else {
        const confirmed = window.confirm('本当に削除しますか？')
        if (confirmed) {
          setLoading(true)
          setLoadingText('モードを削除中...')
          await deletePrompt(_ref)
          // console.log(`モードの削除完了`)
          const { assistantId } = selectedPrompt
          if (assistantId && assistantId !== '') {
            await cleanUpAssistant(assistantId)
          }

          setLoadingText('')
          setLoading(false)
          window.location.reload()
        }
      }
    } catch (error) {
      setLoadingText('')
      setLoading(false)
      return
    }
  }

  const addFolder = async () => {
    if (isAdmin) return
    if (!paramSchoolId) return
    if (!newFolderTitle) {
      alert('フォルダ名は登録必須です。')
      return
    }

    setLoading(true)

    try {
      const datas = []

      // tempフォルダがあれば、デフォルトを作ってしまう
      const categoriesRef = collection(db, 'externalServices', 'mingaku', 'schools', paramSchoolId, 'categories')
      const tempFolder = folders.find((folder) => folder.isTempFolder && folder.prompts && folder.prompts.length > 0)

      if (tempFolder) {
        const defaultFolderName = tempFolder.name ?? 'デフォルト'
        const [newFolderData, defaultFolderData] = await Promise.all(
          [newFolderTitle, defaultFolderName].map((name) => createFolder(categoriesRef, { name, type: 'self' }))
        )
        datas.push(newFolderData)
        datas.push(defaultFolderData)
        setFolderInLocalStorage(newFolderData)

        // 今tempに入っているものたちを一括更新
        const targetPrompts = [...tempFolder.prompts]
        if (targetPrompts.length) {
          await Promise.all(targetPrompts.map((p) => updateDoc(p.ref, { categoryUid: defaultFolderData.uid })))
          setPrompts((prev) => {
            const _prev = [...prev]
            targetPrompts.forEach((prompt) => {
              const _prompt = _prev.find((_) => _.id === prompt.id)
              if (_prompt) {
                _prompt.categoryUid = defaultFolderData.uid
              } else {
                // 何もしない
              }
            })
            return _prev
          })
        }
      } else {
        datas[0] = await createFolder(categoriesRef, { name: newFolderTitle, type: 'self' })
        setFolderInLocalStorage(datas[0])
      }

      setFolderEditScreenShown(false)
      setNewFolderTitle('')
      setCategories((prev) => {
        return [...prev, ...datas]
      })
    } catch (e) {
      console.error(e)
      alert('フォルダの登録に失敗しました。')
    } finally {
      setLoading(false)
      setNewFolderTitle('')
    }
  }

  const createFolder = async (categoriesRef, folderInfo) => {
    if (!folderInfo.name) throw new Error(`folderInfo.name is required`)
    if (!folderInfo.type) throw new Error(`folderInfo.type is required`)

    const newRef = doc(categoriesRef)
    const uid = newRef.id
    const { name, type } = folderInfo
    const data = {
      name,
      type,
      createdAt: Math.floor(Date.now() / 1000),
      description: '',
      uid
    }
    await setDoc(newRef, data)

    return data
  }

  const deleteFolder = async (folderRef) => {
    await deleteDoc(folderRef)
  }

  const editFolder = async () => {
    if (!folderToEdit) return
    if (folderToEdit.type !== 'self') {
      alert('編集する権限がありません。')
      return
    }
    try {
      setLoading(true)
      const categoriesRef = collection(db, 'externalServices', 'mingaku', 'schools', paramSchoolId, 'categories')

      if (folder.uid === 'tempFolder') {
        const data = { name: newFolderTitle, type: 'self' }
        const result = await createFolder(categoriesRef, data)
        const { uid } = result
        const targetPrompts = folderToEdit.prompts ?? []
        await Promise.all(targetPrompts.map((p) => updateDoc(p.ref, { categoryUid: uid })))
        setFolderInLocalStorage(result)
      } else {
        const folderRef = doc(categoriesRef, folderToEdit.uid)
        await updateDoc(folderRef, { name: newFolderTitle })
        setFolderInLocalStorage({ ...folderToEdit, name: newFolderTitle })
      }

      setFolderEditScreenShown(false)
      setNewFolderTitle('')
      setFolderToEdit(null)
      window.location.reload()
    } catch (e) {
      alert('フォルダ名の更新に失敗しました。')
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  const deletePrompts = async (folder) => {
    if (!folder?.prompts?.length) return

    const promises = folder.prompts.map((p) => {
      const _promises = []
      if (p.ref) _promises.push(deleteDoc(p.ref))
      if (p.assistantId) _promises.push(cleanUpAssistant(p.assistantId))
      return _promises.length ? Promise.all(_promises) : Promise.resolve()
    })

    await Promise.all(promises)
  }

  const deleteSelectedFolder = async (folder) => {
    if (!folder) return
    if (isAdmin) return
    if (!paramSchoolId) return
    if (folder.type !== 'self') {
      alert('削除する権限がありません。')
      return
    }
    if (
      !window.confirm(
        'フォルダを削除するとその中に保存されているモードもすべて削除されます。' +
          '\n' +
          `${folder.name}および${folder.name}内のプロンプトをすべて削除しますか？`
      )
    ) {
      return
    }

    try {
      setLoading(true)
      const folderRef = doc(db, 'externalServices', 'mingaku', 'schools', paramSchoolId, 'categories', folder.uid)
      await Promise.all([deleteFolder(folderRef), deletePrompts(folder)])
      setLoading(false)
      window.location.reload()
    } catch (e) {
      console.error(e)
      alert('削除に失敗しました。')
      setLoading(false)
    }
  }

  const displayAddFolderScreen = async () => {
    setFolderEditScreenShown(true)
  }

  const promptLimitSettings = [
    {
      label: '1日あたりの文字数制限',
      checkedCondition: selectedPrompt.character_limit,
      onChange: () =>
        handleInputPromptChange({ character_limit: !selectedPrompt.character_limit, maximum_character_count: 0 }),
      value: selectedPrompt.maximum_character_count,
      field: 'maximum_character_count',
      unit: '文字まで',
      tooltip:
        'ユーザーがこのモードの１スレッドで1日あたり利用できる文字数を設定します。※文字数はインプット・アウトプットの合計文字数です。対話を続ける場合はそれまでの対話履歴の文字数もインプットの文字数にカウントされます。'
    },
    {
      label: '1ヶ月あたりの文字数制限',
      checkedCondition: selectedPrompt.character_limit_per_month,
      onChange: () =>
        handleInputPromptChange({
          character_limit_per_month: !selectedPrompt.character_limit_per_month,
          maximum_character_count_per_month: 0
        }),
      value: selectedPrompt.maximum_character_count_per_month,
      field: 'maximum_character_count_per_month',
      unit: '文字まで',
      tooltip:
        'ユーザーがこのモードの１スレッドで1ヶ月あたり利用できる文字数を設定します。※文字数はインプット・アウトプットの合計文字数です。対話を続ける場合はそれまでの対話履歴の文字数もインプットの文字数にカウントされます。'
    },
    {
      label: '1スレッドあたりの送信回数制限',
      checkedCondition: selectedPrompt.sending_count_limit,
      onChange: () =>
        handleInputPromptChange({
          sending_count_limit: !selectedPrompt.sending_count_limit,
          maximum_sending_count_limit: 20
        }),
      value: selectedPrompt.maximum_sending_count_limit,
      field: 'maximum_sending_count_limit',
      unit: '回まで',
      tooltip: 'ユーザーがこのモードで1スレッドあたりメッセージを送信できる回数を設定します。'
    },
    {
      label: 'AIが記憶するメッセージ件数',
      checkedCondition: selectedPrompt.is_past_message_limit_count_set,
      onChange: () =>
        handleInputPromptChange({
          is_past_message_limit_count_set: !selectedPrompt.is_past_message_limit_count_set,
          maximum_past_message_limit_count: 10
        }),
      value: selectedPrompt.maximum_past_message_limit_count,
      field: 'maximum_past_message_limit_count',
      unit: '件まで',
      tooltip:
        'メッセージを送信する時、メッセージを何件含めるかを設定できます。設定されていない場合は、過去のメッセージが全件送信されます。'
    }
  ]
  const updatePromptLimitValue = (field, value) => {
    const isValidInteger = /^\d*$/.test(value)
    if (!isValidInteger) {
      alert('半角数字で入力してください')
    } else {
      handleInputPromptChange({ [field]: Number(value) })
    }
  }
  const handleTimeWindowChange = (index, field, value) => {
    const newTimeWindows = [...selectedPrompt.time_window]
    newTimeWindows[index] = { ...newTimeWindows[index], [field]: value }
    handleInputPromptChange({ time_window: newTimeWindows })
    // console.log(newTimeWindows)
  }

  const addTimeWindow = () => {
    const newTimeWindows = [...selectedPrompt.time_window, { start: '', end: '' }]
    handleInputPromptChange({ time_window: newTimeWindows })
  }

  const removeTimeWindow = (index) => {
    const newTimeWindows = selectedPrompt.time_window.filter((_, i) => i !== index)
    handleInputPromptChange({ time_window: newTimeWindows })
  }

  useEffect(() => {
    if (isStudentListModalOpen) {
      fetchDocumentIdsForStudent()
    }
  }, [isStudentListModalOpen])

  return (
    <>
      {loading ? (
        <LoadingGrid text={loadingText} />
      ) : (
        <div className={ManagementModule.container}>
          <ManagementScreenList
            filteredModes={filteredModes}
            folders={folders}
            selectedFolder={folder}
            onFolderChange={changeFolder}
            searchText={searchText}
            setSearchText={setSearchText}
            displayAddBody={displayAddBody}
            switchBody={switchBody}
            selectedItem={selectedItem}
            selectedItemClassName={selectedItemClassName}
            schoolIdName={schoolIdName}
            handleCopyModeLink={handleCopyModeLink}
            handleCopyModeShareLink={handleCopyModeShareLink}
            handleModeStart={handleModeStart}
            updateActive={updateActive}
            updateActiveForTeacher={updateActiveForTeacher}
            isChildSchool={isChildSchool}
            displayAddFolderScreen={displayAddFolderScreen}
            isAdmin={isAdmin}
            handleFolderDeletion={deleteSelectedFolder}
            handleFolderEdition={handleFolderEdition}
            isAuthorizedToCreatePrompt={isAuthorizedToCreatePrompt}
          />
          {!folderEditScreenShown ? (
            <>
              <div className={ManagementModule.body}>
                <>
                  <div className={ManagementModule['prompt-body-header']}>
                    <div className={ManagementModule['sub-title-container']}>
                      <h3 className={ManagementModule['sub-title']}>{selectedPrompt ? promptTitle : '新規'}</h3>
                      {selectedPrompt.editable === false && (
                        <b className={ManagementModule['list-title-sub2']}>
                          ※{' '}
                          {selectedPrompt.parentSchoolId !== 'gpt-teacher'
                            ? schoolIdName[selectedPrompt.parentSchoolId]
                            : '管理人'}
                          が作成したモードです
                        </b>
                      )}
                    </div>
                    <div className={ManagementModule['button-container']}>
                      {addBody === true || !selectedPrompt ? (
                        <button
                          className={`${
                            !isAdmin && (!folder || folder.type !== 'self')
                              ? ManagementModule['copy-disabled']
                              : ManagementModule['copy']
                          }`}
                          onClick={() => savePrompt(selectedPrompt)}
                        >
                          作成
                        </button>
                      ) : (
                        <>
                          {selectedPrompt.length !== 0 && (
                            <>
                              <div className={ManagementModule['copy-link-container']}>
                                <CopyToClipboard
                                  text={
                                    selectedPrompt.editable
                                      ? `${linkToCopy}&common=false&showheader=false&ref=${selectedPrompt.ref.path}`
                                      : `${linkToCopy}&common=true&showheader=false&ref=${selectedPrompt.ref.path}`
                                  }
                                  onCopy={handleCopy}
                                >
                                  <CustomWidthTooltip
                                    title="このリンクの受信者は、このモードを利用することができます。"
                                    arrow
                                    enterTouchDelay={100}
                                  >
                                    <LinkIcon className={ManagementModule['copy-link']} />
                                  </CustomWidthTooltip>
                                </CopyToClipboard>
                                <p className={ManagementModule['copy-link-message']}>開始リンク</p>
                                {isCopied && (
                                  <p className={ManagementModule['copied-message']}>リンクをコピーしました！</p>
                                )}
                              </div>
                              {auth.currentUser && !selectedPrompt.hidden && (
                                <>
                                  <div
                                    className={
                                      selectedPrompt.hidden === true
                                        ? ManagementModule['disabled-copy-link-container']
                                        : ManagementModule['copy-link-container']
                                    }
                                  >
                                    <CopyToClipboard
                                      text={
                                        selectedPrompt.editable
                                          ? `${linkForReproduction}&common=false&showheader=false&ref=${selectedPrompt.ref.path}&uidFrom=${auth.currentUser.uid}`
                                          : `${linkForReproduction}&common=true&showheader=false&ref=${selectedPrompt.ref.path}&uidFrom=${auth.currentUser.uid}`
                                      }
                                      onCopy={handleCopy}
                                    >
                                      <CustomWidthTooltip
                                        title={
                                          selectedPrompt.hidden === true
                                            ? 'このモードは共有できません。'
                                            : 'このリンクの受信者(生徒アカウント以外)は、受信者のモード管理画面で、このモードを複製することができます。( ※ 複製後にあなたがこのモードを更新した場合、複製されたモードの方は更新されません。更新させたい場合は再度複製してもらう必要があります。)'
                                        }
                                        arrow
                                        className={ManagementModule['tooltip-arrow']}
                                        enterTouchDelay={100}
                                      >
                                        <LinkIcon className={ManagementModule['copy-link']} />
                                      </CustomWidthTooltip>
                                    </CopyToClipboard>
                                    <p className={ManagementModule['copy-link-message']}>
                                      共有リンク
                                      <br />
                                      (設定公開)
                                    </p>
                                  </div>
                                  <div
                                    className={
                                      selectedPrompt.hidden === true
                                        ? ManagementModule['disabled-copy-link-container']
                                        : ManagementModule['copy-link-container']
                                    }
                                  >
                                    <CopyToClipboard
                                      text={
                                        selectedPrompt.editable
                                          ? `${linkForReproduction}&common=false&showheader=false&canViewContent=false&ref=${selectedPrompt.ref.path}&uidFrom=${auth.currentUser.uid}`
                                          : `${linkForReproduction}&common=true&showheader=false&canViewContent=false&ref=${selectedPrompt.ref.path}&uidFrom=${auth.currentUser.uid}`
                                      }
                                      onCopy={handleCopy}
                                    >
                                      <CustomWidthTooltip
                                        title={
                                          selectedPrompt.hidden === true
                                            ? 'このモードは共有できません。'
                                            : 'このリンクの受信者(生徒アカウント以外)は、このモードを複製できますが、受信者のモード管理画面でこのモードの設定情報を閲覧することができません。'
                                        }
                                        arrow
                                        className={ManagementModule['tooltip-arrow']}
                                        enterTouchDelay={100}
                                      >
                                        <LinkIcon className={ManagementModule['copy-link']} />
                                      </CustomWidthTooltip>
                                    </CopyToClipboard>
                                    <p className={ManagementModule['copy-link-message']}>
                                      共有リンク
                                      <br />
                                      (設定非公開)
                                    </p>
                                  </div>
                                  {selectedPrompt.useAssistantApi || selectedPrompt.hidden ? (
                                    <>
                                      <CustomWidthTooltip
                                        title="アシスタントAPIを使用しているため、このモードは複製できません。"
                                        arrow
                                        className={ManagementModule['tooltip-arrow']}
                                        enterTouchDelay={100}
                                      >
                                        <button className={ManagementModule['copy-disabled']}>複製</button>
                                      </CustomWidthTooltip>
                                    </>
                                  ) : (
                                    <>
                                      <CustomWidthTooltip
                                        title="モード設定をコピーします(※アイコンは複製されません)"
                                        arrow
                                        className={ManagementModule['tooltip-arrow']}
                                        enterTouchDelay={100}
                                      >
                                        <button
                                          className={
                                            isAuthorizedToCreatePrompt
                                              ? ManagementModule['copy']
                                              : ManagementModule['copy-disabled']
                                          }
                                          onClick={(e) => {
                                            if (!isAuthorizedToCreatePrompt) return
                                            copyPrompt(e, selectedPrompt)
                                          }}
                                        >
                                          複製
                                        </button>
                                      </CustomWidthTooltip>
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                          {selectedPrompt.editable === true ? (
                            <button
                              className={ManagementModule['copy']}
                              onClick={() => savePrompt(selectedPrompt)}
                              type="submit"
                            >
                              保存
                            </button>
                          ) : (
                            <button
                              disabled
                              className={ManagementModule['copy-disabled']}
                              onClick={() => savePrompt(selectedPrompt)}
                              type="submit"
                            >
                              保存
                            </button>
                          )}
                          {selectedPrompt.editable === true ? (
                            <button
                              className={ManagementModule['copy']}
                              onClick={() =>
                                deleteSelectedPrompt(
                                  selectedPrompt.id,
                                  selectedPrompt.ref,
                                  selectedPrompt.iconImagePath,
                                  selectedPrompt.iconImagePath2
                                )
                              }
                            >
                              削除
                            </button>
                          ) : (
                            <button
                              disabled
                              className={ManagementModule['copy-disabled']}
                              onClick={() =>
                                deleteSelectedPrompt(
                                  selectedPrompt.id,
                                  selectedPrompt.ref,
                                  selectedPrompt.iconImagePath,
                                  selectedPrompt.iconImagePath2
                                )
                              }
                            >
                              削除
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  {selectedPrompt.hidden ? (
                    <div className={ManagementModule.main}>
                      <p className={ManagementModule['prompt-body']}>モードの詳細は非公開です。</p>
                    </div>
                  ) : (
                    <div className={ManagementModule.main} ref={managementModuleRef}>
                      <p className={ManagementModule.tips}>
                        <span className={ManagementModule['mandatory']}>＊</span>は必須入力です。
                      </p>
                      <div className={`${ManagementModule['management-screen-section']}`}>
                        <h3 className={`${ManagementModule['section-title']}`}>基本設定</h3>
                        <div className={`${ManagementModule['management-screen-row']}`}>
                          {' '}
                          <p className={ManagementModule.label}>
                            <span className={ManagementModule['mandatory']}>＊</span>タイトル
                          </p>
                          <textarea
                            className={ManagementModule['prompt-title']}
                            value={selectedPrompt.prompt_title}
                            onChange={(e) => handleInputPromptChange({ prompt_title: e.target.value })}
                          />
                        </div>
                        <div className={`${ManagementModule['management-screen-row']}`}>
                          <p className={ManagementModule.label}>説明</p>
                          <textarea
                            className={ManagementModule['prompt-title']}
                            value={selectedPrompt.prompt_description}
                            onChange={(e) => handleInputPromptChange({ prompt_description: e.target.value })}
                          />
                        </div>
                        <div className={`${ManagementModule['management-screen-row']}`}>
                          {' '}
                          <div className={`${ManagementModule['color-picker-section']}`}>
                            <p className={ManagementModule.label}>ボタンの色</p>
                            {selectedPrompt.modeColor ? (
                              <div className={`${ManagementModule['color-picker-container']}`}>
                                <div className={`${ManagementModule['color-picker-input']}`}>
                                  <input
                                    type="color"
                                    value={selectedPrompt.modeColor ?? '#ffffff'}
                                    onChange={(e) => onColorChange(e.target?.value, { immediate: false })}
                                  />
                                </div>
                                <div className={`${ManagementModule['color-picker-selection']}`}>
                                  <p className={`${ManagementModule['color-picker-selection-title']}`}>標準の色</p>
                                  <div className={`${ManagementModule['color-picker-selection-options']}`}>
                                    {defaultColors.map((color) => (
                                      <span
                                        key={color.label}
                                        className={`${ManagementModule['color-picker-selection-options-option']}`}
                                        style={{ backgroundColor: color.code }}
                                        onClick={() => onColorChange(color.code)}
                                      ></span>
                                    ))}
                                  </div>
                                </div>
                                <div className={`${ManagementModule['color-picker-button-container']}`}>
                                  <button
                                    className={`${ManagementModule['color-picker-button-container-button']}`}
                                    onClick={() => onColorChange('')}
                                  >
                                    初期設定の色に
                                    <br />
                                    戻す
                                  </button>
                                  <p>※初期設定はこのボタンの色</p>
                                </div>
                              </div>
                            ) : (
                              <div className={`${ManagementModule['color-picker-container']}`}>
                                <p>現在モードのカラーは設定されていません</p>
                                <button className={ManagementModule['copy']} onClick={() => onColorChange('#0000ff')}>
                                  カラー変更
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className={`${ManagementModule['management-screen-row-block']}`}>
                          <div className={`${ManagementModule['']}`}>
                            <div className={ManagementModule['']}>
                              <p className={ManagementModule.label}>表示順</p>
                              <textarea
                                className={ManagementModule['prompt-order']}
                                value={selectedPrompt.prompt_order}
                                onChange={(e) => updatePromptOrder(e.target.value)}
                              />
                            </div>
                          </div>
                          {!isAdmin && !addBody && (
                            <div className={`${ManagementModule['']}`}>
                              <div className={ManagementModule['']}>
                                <p className={ManagementModule.label}>フォルダ</p>
                                <FormControl fullWidth className={ManagementModule.formcontrol}>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    key={folder?.uid ?? 'folderKey'}
                                    defaultValue={(() => {
                                      if (!folder) return ''
                                      if (folder.type !== 'self') return ''
                                      if (folder.type === 'self') return folder?.uid ?? ''
                                      return folders.filter((_) => _.type === 'self')[0]?.uid ?? ''
                                    })()}
                                    onChange={(e) => updatePromptFolder(e.target.value)}
                                    sx={{
                                      height: '35px',
                                      backgroundColor: 'white'
                                    }}
                                  >
                                    {folders
                                      .filter((_) => _.type === 'self')
                                      .map((folder, index) => (
                                        <MenuItem key={index} value={folder.uid}>
                                          {folder.name}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className={`${ManagementModule['management-screen-section']}`}>
                        <h3 className={`${ManagementModule['section-title']}`}>プロンプト</h3>
                        <div className={ManagementModule['prompt-input-4']}>
                          <div className={ManagementModule['prompt-input-fields3']}>
                            <p className={`${ManagementModule.label} ${ManagementModule['section-title']}`}>
                              <span className={ManagementModule['mandatory']}>＊</span>プロンプト(現在
                              {selectedPrompt && selectedPrompt.prompt ? selectedPrompt.prompt.length : 0}文字)
                            </p>
                            <textarea
                              ref={textAreaRef}
                              className={ManagementModule.prompt}
                              value={selectedPrompt.prompt}
                              onChange={(e) => handleInputPromptChange({ prompt: e.target.value })}
                            />
                          </div>
                          <div className={ManagementModule['prompt-input-fields-container']}>
                            <div className={ManagementModule['prompt-input-fields4']}>
                              <p className={ManagementModule.label2}>
                                フォームの差し込み{' '}
                                <CustomWidthTooltip
                                  title="フォームの各質問でユーザーに入力してもらった値がプロンプトに入ります"
                                  arrow
                                  className={ManagementModule['tooltip-arrow']}
                                  enterTouchDelay={100}
                                >
                                  <mark className={ManagementModule['tooltip2']}>？</mark>
                                </CustomWidthTooltip>
                              </p>
                              <div className={ManagementModule['codes-container']}>
                                {selectedPrompt.length !== 0 && selectedPrompt.formQuestions.length > 0 ? (
                                  <>
                                    <ul className={ManagementModule['codes-container-ul']}>
                                      {selectedPrompt.formQuestions.map((question, index) => (
                                        <li key={index}>
                                          <button
                                            className={ManagementModule['codes']}
                                            onClick={() => handleInsertClick(question.key)}
                                          >
                                            {question.title ? question.title : 'タイトルなし'}
                                          </button>
                                        </li>
                                      ))}
                                    </ul>
                                    <div className={ManagementModule['codes-small-container']}>
                                      <p className={ManagementModule['codes-small-container-p']}>
                                        質問の文字数
                                        <CustomWidthTooltip
                                          title="実際にユーザーが質問(テキスト)に入力した文字数が入ります"
                                          arrow
                                          className={ManagementModule['tooltip-arrow']}
                                          enterTouchDelay={100}
                                        >
                                          <mark className={ManagementModule['tooltip2']}>？</mark>
                                        </CustomWidthTooltip>
                                      </p>
                                      <ul className={ManagementModule['codes-small-container-ul']}>
                                        {selectedPrompt.formQuestions
                                          .filter((question) => question.type === 'text')
                                          .map((filteredQuestion, index) => (
                                            <li key={`text-${index}`}>
                                              <button
                                                onClick={() => handleInsertClick(`${filteredQuestion.key}.length`)}
                                                className={ManagementModule['codes']}
                                              >
                                                {filteredQuestion.title
                                                  ? filteredQuestion.title + 'の文字数'
                                                  : 'タイトルなしの文字数'}
                                              </button>
                                            </li>
                                          ))}
                                      </ul>
                                    </div>
                                  </>
                                ) : (
                                  <p>なし</p>
                                )}
                              </div>
                            </div>
                            <br />
                            <div className={ManagementModule['prompt-input-fields4']}>
                              <p className={ManagementModule.label2}>
                                生徒情報（先生の管理画面）の差し込み{' '}
                                <CustomWidthTooltip
                                  title="みんがくに登録されている生徒情報を差し込めます"
                                  arrow
                                  className={ManagementModule['tooltip-arrow']}
                                  enterTouchDelay={100}
                                >
                                  <mark className={ManagementModule['tooltip2']}>？</mark>
                                </CustomWidthTooltip>
                              </p>
                              <div className={ManagementModule['codes-container']}>
                                {studentInfoItemsForInsertion.length > 0 ? (
                                  <ul className={ManagementModule['codes-container-ul']}>
                                    {studentInfoItemsForInsertion.map((item, index) => (
                                      <li key={index}>
                                        <button
                                          className={ManagementModule['codes']}
                                          onClick={() => handleInsertClick(item.key)}
                                        >
                                          {item.title ? item.title : 'タイトルなし'}
                                        </button>
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <p>なし</p>
                                )}
                              </div>
                            </div>
                            <div className={ManagementModule['prompt-input-fields4']}>
                              <p className={ManagementModule.label2}>
                                マイページ情報（生徒のスクールAI画面）情報の差し込み{' '}
                                <CustomWidthTooltip
                                  title="スクールAIのマイページに登録されている情報を差し込めます"
                                  arrow
                                  className={ManagementModule['tooltip-arrow']}
                                  enterTouchDelay={100}
                                >
                                  <mark className={ManagementModule['tooltip2']}>？</mark>
                                </CustomWidthTooltip>
                              </p>
                              <div className={ManagementModule['codes-container']}>
                                <ul className={ManagementModule['codes-container-ul']}>
                                  {/* {_fields_of_user_data_in_mypage.map((item, index) => (
                                  <li key={index}>
                                    <button
                                      className={ManagementModule['codes']}
                                      onClick={() => handleInsertClick(`${item.value}.mypage`)}
                                    >
                                      {item.displayName ? item.displayName : 'タイトルなし'}
                                    </button>
                                  </li>
                                ))} */}
                                  {_fields_of_user_data_in_mypage
                                    .filter((item) => item.mypage !== false) // Filter out items where mypage is false
                                    .map((item, index) => (
                                      <li key={index}>
                                        <button
                                          className={ManagementModule['codes']}
                                          onClick={() => handleInsertClick(`${item.value}.mypage`)}
                                        >
                                          {item.displayName ? item.displayName : 'タイトルなし'}
                                        </button>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={`${ManagementModule['management-screen-section']}`}>
                        <h3 className={ManagementModule['section-title']}>
                          事前入力フォーム
                          <CustomWidthTooltip
                            title="チャット開始前にユーザーに入力してもらい、「差し込みコード」を用いてプロンプトの値として使用することができます"
                            arrow
                            className={ManagementModule['tooltip-arrow']}
                            enterTouchDelay={100}
                          >
                            <span className={ManagementModule['tooltip2']}>？</span>
                          </CustomWidthTooltip>
                        </h3>
                        <div className={ManagementModule['prompt-body']}>
                          <div className={ManagementModule['prompt-input3']}>
                            <div className={ManagementModule['prompt-input-fields-container4']}>
                              <span className={ManagementModule['sub-field']}>フォームの入力内容をチャットに表示</span>
                              <Switch2
                                checked={selectedPrompt.displayInputContents}
                                onChange={() =>
                                  handleInputPromptChange({
                                    displayInputContents: !selectedPrompt.displayInputContents
                                  })
                                }
                              />
                            </div>
                          </div>
                          {selectedPrompt.displayInputContents && (
                            <div className={ManagementModule['prompt-input3']}>
                              <div className={ManagementModule['prompt-input-fields-container4']}>
                                <span className={ManagementModule['sub-field']}>
                                  フォームの入力内容を展開したままチャットに表示
                                </span>

                                <Switch2
                                  checked={selectedPrompt.expandInputContents ?? false}
                                  onChange={() =>
                                    handleInputPromptChange({
                                      expandInputContents: !selectedPrompt.expandInputContents
                                    })
                                  }
                                />
                              </div>
                            </div>
                          )}
                          {selectedPrompt &&
                            selectedPrompt.formQuestions &&
                            selectedPrompt.formQuestions.map((formQuestions, index) => (
                              <div key={index} className={ManagementModule['input-container']}>
                                <div className={ManagementModule['prompt-input-container']}>
                                  <div className={ManagementModule['prompt-input2']}>
                                    <div className={ManagementModule['prompt-input-fields2-order']}>
                                      <p className={ManagementModule.label}>表示順</p>
                                      <textarea
                                        className={ManagementModule['question-order']}
                                        value={formQuestions.order}
                                        size="sm"
                                        onChange={(e) => {
                                          handleQuestionOrderChange(e.target.value, index)
                                        }}
                                      />
                                    </div>
                                    <div className={ManagementModule['prompt-input-fields2']}>
                                      <p className={ManagementModule.label}>質問のタイプ</p>
                                      <FormControl fullWidth className={ManagementModule.formcontrol}>
                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={formQuestions.type}
                                          onChange={(e) => handleQuestionTypeChange(e.target.value, index)}
                                          sx={{
                                            height: '35px',
                                            backgroundColor: 'white'
                                          }}
                                        >
                                          {_question_type.map((item, index) => (
                                            <MenuItem key={index} value={item.value}>
                                              {item.displayName}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </div>
                                    <div className={ManagementModule['prompt-input-fields2']}>
                                      <p className={ManagementModule.label}>
                                        <span className={ManagementModule['mandatory']}>＊</span>差し込みコード
                                      </p>
                                      <textarea
                                        placeholder="半角英数で設定"
                                        className={ManagementModule['question-title']}
                                        onChange={(e) => handleQuestionKeyChange(e.target.value, index)}
                                        required
                                        value={formQuestions.key}
                                        size="sm"
                                      >
                                        {formQuestions.key}
                                      </textarea>
                                    </div>
                                  </div>
                                  <div
                                    className={ManagementModule['question-delete']}
                                    onClick={() => addToDeleteQuestionArray(index)}
                                  >
                                    <DeleteOutlineIcon />
                                  </div>
                                </div>
                                {formQuestions.type == 'image' && (
                                  <p className={ManagementModule['tips2']}>※画像タイプは途中変更不可です。</p>
                                )}
                                {formQuestions.type === 'text' && (
                                  <>
                                    <div className={ManagementModule['prompt-input3']}>
                                      <div className={ManagementModule['prompt-input-fields-container1']}>
                                        <span className={ManagementModule['sub-field']}>回答の文字数制限</span>
                                        <Switch2
                                          checked={
                                            !!formQuestions.answerCharacterLimit
                                              ? formQuestions.answerCharacterLimit
                                              : false
                                          }
                                          onChange={() =>
                                            updatePromptFormQuestionCharacterLimit(
                                              formQuestions.answerCharacterLimit,
                                              index
                                            )
                                          }
                                        />
                                      </div>
                                      {formQuestions.type === 'text' && formQuestions.answerCharacterLimit && (
                                        <div className={ManagementModule['prompt-input-fields-container2']}>
                                          <div className={ManagementModule['prompt-input-fields5']}>
                                            <div className={ManagementModule['field-container']}>
                                              <textarea
                                                size="sm"
                                                placeholder=""
                                                className={ManagementModule['prompt-order2']}
                                                onChange={(e) =>
                                                  handleFormQuestionAnswerMaxLengthChange(e.target.value, index)
                                                }
                                                required
                                                value={formQuestions.answerMaxLength}
                                              >
                                                {formQuestions.answerMaxLength}
                                              </textarea>
                                              <span>文字まで</span>
                                            </div>
                                          </div>
                                          <div>
                                            <p className={ManagementModule['p-tooltip']}>
                                              ユーザーが質問に入力できる最大文字数を設定します
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </>
                                )}
                                <>
                                  <div className={ManagementModule['prompt-input3']}>
                                    <div className={ManagementModule['prompt-input-fields-container1']}>
                                      <span className={ManagementModule['sub-field']}>入力の必須</span>
                                      <Switch2
                                        onText="必須"
                                        offText="任意"
                                        checked={!!formQuestions.mandatory}
                                        onChange={() =>
                                          updatePromptFormQuestionMandatory(formQuestions.mandatory, index)
                                        }
                                        // disabled={formQuestions.type === 'image'}
                                      />
                                    </div>
                                  </div>
                                  <div className={ManagementModule['prompt-input3']}>
                                    <div className={ManagementModule['prompt-input-fields-container1']}>
                                      <span className={ManagementModule['sub-field']}>途中変更可能</span>
                                      <Switch2
                                        onText="有効"
                                        offText="無効"
                                        // checked={!!formQuestions.changeable ? formQuestions.changeable : false}
                                        checked={formQuestions.type === 'image' ? false : !!formQuestions.changeable}
                                        disabled={formQuestions.type === 'image'} // 強制的に無効化
                                        onChange={() =>
                                          updatePromptFormQuestionChangeable(formQuestions.changeable, index)
                                        }
                                      />
                                    </div>
                                  </div>
                                </>
                                <div className={ManagementModule['input-section2']}>
                                  <div>
                                    <p className={ManagementModule.label3}>
                                      <span className={ManagementModule['mandatory']}>＊</span>質問タイトル
                                    </p>
                                    <textarea
                                      className={ManagementModule['question-title']}
                                      onChange={(e) => handleQuestionTitleChange(e.target.value, index)}
                                      value={formQuestions.title}
                                    >
                                      {formQuestions.title}
                                    </textarea>
                                    <p className={ManagementModule.label3}>質問の説明</p>
                                    <textarea
                                      className={ManagementModule['question-instruction']}
                                      onChange={(e) => handleQuestionDescriptionChange(e.target.value, index)}
                                      value={formQuestions.description}
                                    >
                                      {formQuestions.description}
                                    </textarea>
                                  </div>

                                  {formQuestions.type === 'pulldown' && (
                                    <>
                                      <div className={ManagementModule['title-container']}>
                                        <p className={ManagementModule['label3']}>選択肢</p>
                                        <button
                                          className={ManagementModule['long-text']}
                                          onClick={() => openModal(index)}
                                        >
                                          ※テンプレートを使う
                                        </button>
                                      </div>
                                      <div className={ManagementModule['response-options-container']}>
                                        {inputResponseOptions.length > 0 && (
                                          <table className={ManagementModule['options-table']}>
                                            <thead>
                                              <tr>
                                                <th className={ManagementModule.order}>順番</th>
                                                <th className={ManagementModule.option}>
                                                  <span className={ManagementModule['mandatory']}>＊</span>選択肢名
                                                </th>
                                                <th className={ManagementModule.optionContent}>
                                                  選択肢の値（選択肢が選ばれた時に、AIに送信される文言）
                                                  <CustomWidthTooltip
                                                    title="選択肢の値がブランクの場合、選択肢名が値として入ります"
                                                    arrow
                                                    className={ManagementModule['tooltip-arrow']}
                                                    enterTouchDelay={100}
                                                  >
                                                    <mark className={ManagementModule['tooltip2']}>？</mark>
                                                  </CustomWidthTooltip>
                                                </th>
                                                <th className={ManagementModule.delete}>　</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {formQuestions &&
                                                formQuestions.options &&
                                                formQuestions.options.map((option, o_index) => (
                                                  <tr key={o_index}>
                                                    <td>
                                                      <textarea
                                                        value={option.order}
                                                        className={ManagementModule['order']}
                                                        onChange={(e) => {
                                                          handleFormQuestionsOptionsOrderChange(
                                                            e.target.value,
                                                            index,
                                                            o_index
                                                          )
                                                        }}
                                                      />
                                                    </td>
                                                    <td>
                                                      <textarea
                                                        value={option.displayName}
                                                        className={ManagementModule['option']}
                                                        onChange={(e) => {
                                                          handleFormQuestionsOptionsDisplayNameChange(
                                                            e.target.value,
                                                            index,
                                                            o_index
                                                          )
                                                        }}
                                                      />
                                                    </td>
                                                    <td>
                                                      <textarea
                                                        value={option.value}
                                                        className={ManagementModule['optionContent']}
                                                        onChange={(e) => {
                                                          handleFormQuestionsOptionsValueChange(
                                                            e.target.value,
                                                            index,
                                                            o_index
                                                          )
                                                        }}
                                                      />
                                                    </td>
                                                    <td>
                                                      <div className={ManagementModule['add-container']}>
                                                        <div
                                                          className={ManagementModule['delete']}
                                                          onClick={() =>
                                                            addToDeleteFormQuestionOptionsArray(index, o_index)
                                                          }
                                                        >
                                                          <DeleteOutlineIcon />
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                ))}
                                            </tbody>
                                          </table>
                                        )}
                                        <div className={ManagementModule['add-container']}>
                                          <div className={ManagementModule['add']}>
                                            <AddCircleIcon
                                              className={ManagementModule.icon}
                                              onClick={() => addFormQuestionOptionsFields(index)}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  {isModalOpen && (
                                    <div className={ManagementModule.modalWrapper}>
                                      <div className={ManagementModule.overlay}></div>
                                      <div className={ManagementModule.modal}>
                                        <p className={ManagementModule['modal-text']}>プルダウン　選択肢テンプレート</p>
                                        <FormControl fullWidth className={ManagementModule.formcontrol}>
                                          <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={pulldownTemplate}
                                            sx={{
                                              height: '35px',
                                              backgroundColor: 'white'
                                            }}
                                            onChange={(e) => setPulldownTemplate(e.target.value)}
                                          >
                                            {_pulldownTemplates.map((template, p_index) => (
                                              <MenuItem key={p_index} value={JSON.stringify(template)}>
                                                {template.name}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                        <p className={ManagementModule['modal-text']}>※プレビュー</p>
                                        {JSON.parse(pulldownTemplate).selectOptions.map((option, o_index) => (
                                          <div key={o_index} className={ManagementModule['option-list']}>
                                            <div className={ManagementModule['option-fields']}>
                                              <textarea
                                                disabled
                                                value={option.order}
                                                size="sm"
                                                className={ManagementModule.order}
                                              />
                                              <textarea
                                                disabled
                                                value={option.displayName}
                                                size="sm"
                                                className={ManagementModule.option}
                                              />
                                              <textarea
                                                disabled
                                                value={option.value}
                                                size="sm"
                                                className={ManagementModule.optionContent}
                                              />
                                            </div>
                                          </div>
                                        ))}
                                        <button className={ManagementModule['close-button']} onClick={closeModal}>
                                          <p className={ManagementModule['sub-button-text']}>キャンセル</p>
                                        </button>
                                        <button
                                          className={ManagementModule['close-button']}
                                          onClick={() => closeModalAndChangeFormQuestions(pulldownTemplate, modalIndex)}
                                        >
                                          <p className={ManagementModule['sub-button-text']}>確定</p>
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          <div className={ManagementModule['add-container']}>
                            <div className={ManagementModule['add']}>
                              <AddCircleIcon className={ManagementModule.icon} onClick={addFormQuestionFields} />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={`${ManagementModule['management-screen-section']}`}>
                        <h3 className={`${ManagementModule['section-title']}`}>アイコン</h3>
                        <div className={ManagementModule['prompt-input3']}>
                          <div className={ManagementModule['prompt-input-fields-container1']}>
                            <span className={ManagementModule['sub-field']}>アイコンの大きさ</span>
                            <Switch2
                              onText=" 大"
                              offText="小"
                              checked={selectedPrompt.largeIcon}
                              onChange={() => handleInputPromptChange({ largeIcon: !selectedPrompt.largeIcon })}
                            />
                          </div>
                        </div>
                        <div className={ManagementModule['prompt-input']}>
                          <div className={ManagementModule['prompt-input-fields']}>
                            <label className={ManagementModule['long-text']} htmlFor="file_upload1">
                              アイコン①を選ぶ
                              <input id="file_upload1" type="file" onChange={handleImage} />
                            </label>
                            <CustomWidthTooltip
                              title="デフォルト画像です"
                              arrow
                              className={ManagementModule['tooltip-arrow']}
                              enterTouchDelay={100}
                            >
                              <mark className={ManagementModule['tooltip2']}>？</mark>
                            </CustomWidthTooltip>
                            {imageUrl && (
                              <>
                                <div className={ManagementModule['icon-container']}>
                                  <img className={ManagementModule['icon-image']} src={imageUrl} alt="" />
                                </div>
                                <button className={ManagementModule['long-text']} onClick={() => deleteImage()}>
                                  アイコン①を削除する...
                                </button>
                              </>
                            )}
                            {selectedPrompt.iconImageUrl && !imageUrl ? (
                              <>
                                <div className={ManagementModule['icon-container']}>
                                  <img
                                    className={ManagementModule['icon-image']}
                                    src={selectedPrompt.iconImageUrl}
                                    alt=""
                                  />
                                </div>
                                <button
                                  className={ManagementModule['long-text']}
                                  onClick={() =>
                                    handleInputPromptChange({
                                      iconImageUrl: ''
                                    })
                                  }
                                >
                                  アイコン①を削除する
                                </button>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className={ManagementModule['prompt-input-fields']}>
                            <label className={ManagementModule['long-text']} htmlFor="file_upload2">
                              アイコン②を選ぶ
                              <input id="file_upload2" type="file" onChange={handleImage2} />
                            </label>
                            <CustomWidthTooltip
                              title="動作時にデフォルトと交互にでる画像です"
                              arrow
                              className={ManagementModule['tooltip-arrow']}
                              enterTouchDelay={100}
                            >
                              <mark className={ManagementModule['tooltip2']}>？</mark>
                            </CustomWidthTooltip>
                            {imageUrl2 && (
                              <>
                                <div className={ManagementModule['icon-container']}>
                                  <img className={ManagementModule['icon-image']} src={imageUrl2} alt="" />
                                </div>
                                <button className={ManagementModule['long-text']} onClick={() => deleteImage2()}>
                                  アイコン②を削除する...
                                </button>
                              </>
                            )}
                            {selectedPrompt.iconImageUrl2 && !imageUrl2 ? (
                              <>
                                <div className={ManagementModule['icon-container']}>
                                  <img
                                    className={ManagementModule['icon-image']}
                                    src={selectedPrompt.iconImageUrl2}
                                    alt=""
                                  />
                                </div>
                                <button
                                  className={ManagementModule['long-text']}
                                  onClick={() =>
                                    handleInputPromptChange({
                                      iconImageUrl2: ''
                                    })
                                  }
                                >
                                  アイコン②を削除する
                                </button>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className={`${ManagementModule['management-screen-section']}`}>
                        <h3 className={ManagementModule['section-title']}>返答選択肢</h3>
                        <div className={`${ManagementModule['display-message-setting-container']}`}>
                          <span className={ManagementModule['sub-field']}>送信される内容をチャット上で表示しない</span>
                          <Switch2
                            checked={selectedPrompt.useDisplayMessage}
                            onChange={() =>
                              handleInputPromptChange({ useDisplayMessage: !selectedPrompt.useDisplayMessage })
                            }
                          />
                        </div>
                        <div className={ManagementModule['response-options-container']}>
                          {selectedPrompt && selectedPrompt.responseOptions.length > 0 && (
                            <table className={ManagementModule['options-table']}>
                              <thead>
                                <tr>
                                  <th className={ManagementModule.order}>順番</th>
                                  <th className={ManagementModule.option}>選択肢名</th>
                                  <th className={ManagementModule.optionContent}>送信される内容</th>
                                  <th className={ManagementModule.delete}>　</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedPrompt.responseOptions.map((responseOption, index) => (
                                  <tr key={index}>
                                    <td>
                                      <textarea
                                        value={responseOption.order}
                                        className={ManagementModule['order']}
                                        onChange={(e) => handleOptionOrderChange(e.target.value, index)}
                                      />
                                    </td>
                                    <td>
                                      <textarea
                                        value={responseOption.option}
                                        className={ManagementModule['option']}
                                        onChange={(e) => handleOptionChange(e.target.value, index)}
                                      />
                                    </td>
                                    <td>
                                      <textarea
                                        value={responseOption.content}
                                        className={ManagementModule['optionContent']}
                                        onChange={(e) => handleOptionContentChange(e.target.value, index)}
                                      />
                                    </td>
                                    <td>
                                      <div className={ManagementModule['add-container']}>
                                        <div
                                          className={ManagementModule['delete']}
                                          onClick={() => addToDeleteArray(index)}
                                        >
                                          <DeleteOutlineIcon />
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                          <div className={ManagementModule['add-container']}>
                            <div className={ManagementModule['add']}>
                              <AddCircleIcon className={ManagementModule.icon} onClick={addToAddArray} />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={`${ManagementModule['management-screen-section']}`}>
                        <h3 className={ManagementModule['section-title']}>リンク設定</h3>
                        <div className={ManagementModule['response-options-container']}>
                          {selectedPrompt && selectedPrompt.responseOptions.length > 0 && (
                            <table className={ManagementModule['options-table']}>
                              <thead>
                                <tr>
                                  <th className={ManagementModule.order}>順番</th>
                                  <th className={ManagementModule.option}>表示名</th>
                                  <th className={ManagementModule.optionContent}>遷移するURL</th>
                                  <th className={ManagementModule.delete}>　</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedPrompt.links &&
                                  selectedPrompt.links.map((link, index) => (
                                    <tr key={index}>
                                      <td>
                                        <textarea
                                          value={link.order}
                                          className={ManagementModule['order']}
                                          onChange={(e) => handleLinkChange(e.target.value, index, 'order')}
                                        />
                                      </td>
                                      <td>
                                        <textarea
                                          value={link.name}
                                          className={ManagementModule['option']}
                                          onChange={(e) => handleLinkChange(e.target.value, index, 'name')}
                                        />
                                      </td>
                                      <td>
                                        <textarea
                                          value={link.uri}
                                          className={ManagementModule['optionContent']}
                                          onChange={(e) => handleLinkChange(e.target.value, index, 'uri')}
                                        />
                                      </td>
                                      <td>
                                        <div className={ManagementModule['add-container']}>
                                          <div className={ManagementModule['delete']} onClick={() => removeLink(index)}>
                                            <DeleteOutlineIcon />
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          )}
                          <div className={ManagementModule['add-container']}>
                            <div className={ManagementModule['add']}>
                              <AddCircleIcon className={ManagementModule.icon} onClick={addNewLinkSpot} />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={`${ManagementModule['management-screen-section']}`}>
                        <h3 className={ManagementModule['section-title']}>詳細設定</h3>
                        <div className={ManagementModule['prompt-input']}>
                          <div className={ManagementModule['prompt-input-fields']}>
                            <p className={ManagementModule.label}>生成AIモデル</p>
                            <FormControl fullWidth className={ManagementModule.formcontrol}>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedPrompt.model || ''}
                                onChange={(e) => updatePromptModel(e.target.value)}
                                sx={{
                                  height: '35px',
                                  backgroundColor: 'white'
                                }}
                              >
                                {constantData._gpt_model.map((item, index) => (
                                  <MenuItem key={index} value={item.value}>
                                    {item.customDisplayName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                          {/* デフォルト言語 */}
                          <div className={ManagementModule['prompt-input-fields']}>
                            <p className={ManagementModule.label}>
                              言語
                              <CustomWidthTooltip
                                title="AIの音声入力の認識、音声出力をどの言語でするかを設定します。全言語の場合処理が遅くなる可能性があります。"
                                arrow
                                className={ManagementModule['tooltip-arrow']}
                                enterTouchDelay={100}
                              >
                                <mark className={ManagementModule['tooltip2']}>？</mark>
                              </CustomWidthTooltip>
                            </p>
                            <FormControl fullWidth className={ManagementModule.formcontrol}>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedPrompt.prompt_language2 ? selectedPrompt.prompt_language2 : ''}
                                onChange={(e) =>
                                  handleInputPromptChange({
                                    prompt_language2: e.target.value
                                  })
                                }
                                sx={{
                                  height: '35px',
                                  backgroundColor: 'white'
                                }}
                              >
                                {languageList2.map((language) => (
                                  <MenuItem key={JSON.stringify(language)} value={JSON.stringify(language)}>
                                    {language.title}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        {(() => {
                          const selectedModel = constantData._gpt_model.find(
                            (item) => item.value === selectedPrompt.model
                          )
                          return selectedModel?.availableAssistApi && selectedModel?.provider === 'microsoft'
                        })() ? (
                          <div className={ManagementModule['prompt-input']}>
                            <div className={ManagementModule['prompt-assistant-api-container']}>
                              <div className={ManagementModule['prompt-input3']}>
                                <div className={ManagementModule['assistant-api-container']}>
                                  <span className={ManagementModule['sub-field']}>
                                    【試験運用中】ファイルを学習させる(AssisntantAPIを利用する)
                                  </span>
                                  <Switch2
                                    checked={!!selectedPrompt.useAssistantApi ? selectedPrompt.useAssistantApi : false}
                                    onChange={() =>
                                      handleInputPromptChange({ useAssistantApi: !selectedPrompt.useAssistantApi })
                                    }
                                  />
                                </div>
                              </div>
                              {selectedPrompt.useAssistantApi && (
                                <div className={ManagementModule['prompt-assistant-api-sub-container']}>
                                  <p className={ManagementModule['instruction']}>役割</p>
                                  <textarea
                                    value={
                                      selectedPrompt.assistantApiInstruction
                                        ? selectedPrompt.assistantApiInstruction
                                        : ''
                                    }
                                    size="sm"
                                    className={ManagementModule['instruction-area']}
                                    onChange={(e) => {
                                      handleInputPromptChange({ assistantApiInstruction: e.target.value })
                                    }}
                                  />
                                  <div className={ManagementModule['select-assistant-api-files']}>
                                    <label
                                      className={ManagementModule['icon-select']}
                                      htmlFor="assistant_api_file_upload"
                                    >
                                      ファイルを選ぶ
                                      <input
                                        id="assistant_api_file_upload"
                                        type="file"
                                        multiple
                                        onChange={handleAssistantApiFileUpload}
                                      />
                                    </label>
                                  </div>
                                  <div className={ManagementModule['file-container']}>
                                    <table className={ManagementModule['options-table2']}>
                                      <thead>
                                        <tr>
                                          <th className={ManagementModule.order}></th>
                                          <th className={ManagementModule.delete}></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {updatedAssistantFiles &&
                                          updatedAssistantFiles.map((file, index) => (
                                            <tr key={index}>
                                              <td>
                                                <p className={ManagementModule['uploaded-file-name']}>・{file.name}</p>
                                              </td>
                                              <td>
                                                <div className={ManagementModule['add-container2']}>
                                                  <div
                                                    className={ManagementModule.delete}
                                                    onClick={() => handleDeleteFile(file, index)}
                                                  >
                                                    <DeleteOutlineIcon />
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <></>
                          // <div className={ManagementModule['prompt-input']}>
                          //   <div className={ManagementModule['prompt-assistant-api-container']}>
                          //     <div className={ManagementModule['prompt-input3']}>
                          //       <div className={ManagementModule['assistant-api-container']}>
                          //         <span className={ManagementModule['sub-field']}>AssistantAPIを使用</span>
                          //         <Switch2
                          //           checked={!!selectedPrompt.useAssistantApi ? selectedPrompt.useAssistantApi : false}
                          //           onChange={() =>
                          //             handleInputPromptChange({ useAssistantApi: !selectedPrompt.useAssistantApi })
                          //           }
                          //         />
                          //       </div>
                          //     </div>
                          //     {selectedPrompt.useAssistantApi && (
                          //       <div className={ManagementModule['prompt-assistant-api-sub-container']}>
                          //         <p className={ManagementModule['instruction']}>AssistantAPIの役割</p>
                          //         <textarea
                          //           value={
                          //             selectedPrompt.assistantApiInstruction ? selectedPrompt.assistantApiInstruction : ''
                          //           }
                          //           size="sm"
                          //           className={ManagementModule['instruction-area']}
                          //           onChange={(e) => {
                          //             handleInputPromptChange({ assistantApiInstruction: e.target.value })
                          //           }}
                          //         />
                          //         <div className={ManagementModule['select-assistant-api-files']}>
                          //           <label
                          //             className={ManagementModule['icon-select']}
                          //             htmlFor="assistant_api_file_upload"
                          //           >
                          //             ファイルを選ぶ
                          //             <input
                          //               id="assistant_api_file_upload"
                          //               type="file"
                          //               multiple
                          //               onChange={handleAssistantApiFileUpload}
                          //             />
                          //           </label>
                          //         </div>
                          //         <div className={ManagementModule['file-container']}>
                          //           <table className={ManagementModule['options-table2']}>
                          //             <thead>
                          //               <tr>
                          //                 <th className={ManagementModule.order}></th>
                          //                 <th className={ManagementModule.delete}></th>
                          //               </tr>
                          //             </thead>
                          //             <tbody>
                          //               {updatedAssistantFiles &&
                          //                 updatedAssistantFiles.map((file, index) => (
                          //                   <tr key={index}>
                          //                     <td>
                          //                       <p className={ManagementModule['uploaded-file-name']}>{file.name}</p>
                          //                     </td>
                          //                     <td>
                          //                       <div className={ManagementModule['add-container2']}>
                          //                         <div
                          //                           className={ManagementModule.delete}
                          //                           onClick={() => handleDeleteFile(file, index)}
                          //                         >
                          //                           <DeleteOutlineIcon />
                          //                         </div>
                          //                       </div>
                          //                     </td>
                          //                   </tr>
                          //                 ))}
                          //             </tbody>
                          //           </table>
                          //         </div>
                          //       </div>
                          //     )}
                          //   </div>
                          // </div>
                        )}
                        <div className={ManagementModule['prompt-input']}>
                          <div className={ManagementModule['prompt-input-fields']}>
                            <p className={ManagementModule.label}>音声の出力</p>
                            <FormControl fullWidth className={ManagementModule.formcontrol}>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedPrompt.defaultMute ?? false}
                                onChange={(e) => handleInputPromptChange({ defaultMute: e.target.value })}
                                sx={{
                                  height: '35px',
                                  backgroundColor: 'white'
                                }}
                              >
                                {_default_mute.map((item, index) => (
                                  <MenuItem key={index} value={item.value}>
                                    {item.displayName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                          {/* 音声自動送信 */}
                          <div className={ManagementModule['prompt-input-fields']}>
                            <p className={ManagementModule.label}>音声入力の自動送信</p>
                            <FormControl fullWidth className={ManagementModule.formcontrol}>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedPrompt.autoSending || false}
                                onChange={(e) => handleInputPromptChange({ autoSending: e.target.value })}
                                sx={{
                                  height: '35px',
                                  backgroundColor: 'white'
                                }}
                              >
                                {_auto_sending.map((item, index) => (
                                  <MenuItem key={index} value={item.value}>
                                    {item.displayName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        <div className={ManagementModule['prompt-input']}>
                          {/* gpt精度 */}
                          <div className={ManagementModule['prompt-input-fields']}>
                            <p className={ManagementModule.label}>
                              {`AI返答のランダム性(0 - 2.0)`}
                              <CustomWidthTooltip
                                title="デフォルトは1、小さいほど厳密に、大きいほど多様な出力となります。"
                                arrow
                                className={ManagementModule['tooltip-arrow']}
                                enterTouchDelay={100}
                              >
                                <mark className={ManagementModule['tooltip2']}>？</mark>
                              </CustomWidthTooltip>
                            </p>
                            <input
                              className={ManagementModule['number-select']}
                              type="number"
                              step="0.1"
                              value={selectedPrompt.temperature}
                              onChange={(e) => updatePromptTemperature(e.target.value)}
                            ></input>
                          </div>
                          {/* 会話速度 */}
                          <div className={ManagementModule['prompt-input-fields']}>
                            <p className={ManagementModule.label}>
                              {`AI音声の速度(0.25 - 4.0)`}
                              <CustomWidthTooltip
                                title="1が通常速度で、数値が大きくなるほど速くなります。"
                                arrow
                                className={ManagementModule['tooltip-arrow']}
                                enterTouchDelay={100}
                              >
                                <mark className={ManagementModule['tooltip2']}>？</mark>
                              </CustomWidthTooltip>{' '}
                            </p>
                            <input
                              className={ManagementModule['number-select']}
                              type="number"
                              step="0.1"
                              value={selectedPrompt.speakingRate ? selectedPrompt.speakingRate : 1.1}
                              onChange={(e) => updatePromptSpeakingRate(e.target.value)}
                            ></input>
                          </div>
                        </div>

                        {(!paramSchoolId || roleInMingaku === 'serviceProvider') &&
                          selectedPrompt.editable === true && (
                            <div className={ManagementModule['prompt-body']}>
                              <SchoolUsageModal
                                isOpen={isSchoolUsageModalOpen}
                                onOpen={() => setSchoolUsageModalOpen(true)}
                                onClose={() => setSchoolUsageModalOpen(false)}
                                selectedPrompt={selectedPrompt}
                                handleInputAvailableAllSchoolsChange={handleInputAvailableAllSchoolsChange}
                                searchQuery={searchQuery}
                                setSearchQuery={setSearchQuery}
                                handleSelectAll={handleSelectAll}
                                handleDeselectAll={handleDeselectAll}
                                filteredIds={filteredIds}
                                schoolIdName={schoolIdName}
                                selectedIds={selectedIds}
                                handleCheckboxChange={handleCheckboxChange}
                              />
                              <SchoolViewModal
                                isOpen={isSchoolViewModalOpen}
                                onOpen={() => setSchoolViewModalOpen(true)}
                                onClose={() => setSchoolViewModalOpen(false)}
                                selectedPrompt={selectedPrompt}
                                handleInputViewableAllSchoolsChange={handleInputViewableAllSchoolsChange}
                                viewableSearchQuery={viewableSearchQuery}
                                setViewableSearchQuery={setViewableSearchQuery}
                                handleViewableSelectAll={handleViewableSelectAll}
                                handleViewableDeselectAll={handleViewableDeselectAll}
                                filteredViewableIds={filteredViewableIds}
                                schoolIdName={schoolIdName}
                                viewableSelectedIds={viewableSelectedIds}
                                handleViewableCheckboxChange={handleViewableCheckboxChange}
                              />
                            </div>
                          )}
                        {paramSchoolId && !selectedPrompt.parentSchoolId && (
                          <>
                            <ClassRoomUsageModal
                              classRoomData={classRoomData}
                              isOpen={isClassRoomUsageModalOpen}
                              onOpen={() => setClassRoomUsageModalOpen(true)}
                              onClose={() => setClassRoomUsageModalOpen(false)}
                              selectedPrompt={selectedPrompt}
                              handleInputAvailableAllClassRoomsChange={handleInputAvailableAllClassRoomChange}
                              searchQuery={searchQueryOfClassRoom}
                              setSearchQuery={setSearchQueryOfClassRoom}
                              handleSelectAll={handleSelectAllClassRoom}
                              handleDeselectAll={handleDeselectAllClassRoom}
                              filteredIds={filteredClassRoomIds}
                              schoolIdName={schoolIdName}
                              selectedIds={selectedClassRoomIds}
                              handleCheckboxChange={handleClassRoomCheckboxChange}
                              schoolName={schoolName}
                            />
                            <StudentListModal
                              classRoomData={classRoomData}
                              isOpen={isStudentListModalOpen}
                              onOpen={() => setStudentListModalOpen(true)}
                              onClose={() => setStudentListModalOpen(false)}
                              selectedPrompt={selectedPrompt}
                              handleInputAvailableAllStudentsChange={handleInputAvailableAllStudentsChange}
                              searchFields={searchFields}
                              searchQueries={searchQueries}
                              setSearchQueries={setSearchQueries}
                              handleSelectAllStudent={handleSelectAllStudent}
                              handleDeselectAllStudent={handleDeselectAllStudent}
                              loadingForStudentData={loadingForStudentData}
                              filteredIdsForStudent={filteredIdsForStudent}
                              selectedStudentIds={selectedStudentIds}
                              handleStudentCheckboxChange={handleStudentCheckboxChange}
                            />
                          </>
                        )}
                      </div>

                      <div className={`${ManagementModule['management-screen-section']}`}>
                        <h3 className={ManagementModule['section-title']}>利用制限</h3>
                        {promptLimitSettings.map((setting, index) => (
                          <div className={ManagementModule['prompt-input3']} key={index}>
                            <div className={ManagementModule['prompt-input-fields-container1']}>
                              <span className={ManagementModule['sub-field']}>{setting.label}</span>
                              <Switch2 checked={setting.checkedCondition} onChange={setting.onChange} />
                            </div>
                            {setting.checkedCondition && (
                              <div className={ManagementModule['prompt-input-fields-container2']}>
                                <div className={ManagementModule['prompt-input-fields5']}>
                                  <div className={ManagementModule['field-container']}>
                                    <textarea
                                      className={ManagementModule['prompt-order2']}
                                      value={setting.value}
                                      onChange={(e) => updatePromptLimitValue(setting.field, e.target.value)}
                                    />
                                    <span>{setting.unit}</span>
                                  </div>
                                </div>
                                <div>
                                  <p className={ManagementModule['p-tooltip']}>{setting.tooltip}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                        <div className={ManagementModule['prompt-input3']}>
                          <div className={ManagementModule['prompt-input-fields-container1']}>
                            <span className={ManagementModule['sub-field']}>{'モードの利用時間制限'}</span>
                            <Switch2
                              checked={selectedPrompt.time_window_limit}
                              onChange={() =>
                                handleInputPromptChange({
                                  time_window_limit: !selectedPrompt.time_window_limit,
                                  time_window: [{ start: '00:00', end: '23:59' }]
                                })
                              }
                            />
                          </div>
                          {selectedPrompt.time_window_limit && (
                            <div className={ManagementModule['prompt-input-fields-container2']}>
                              <div className={ManagementModule['prompt-input-fields5']}>
                                <div className={ManagementModule['field-container2']}>
                                  {selectedPrompt.time_window.map((time, index) => (
                                    <div key={index} className={ManagementModule['time-window-item']}>
                                      <input
                                        type="time"
                                        className={ManagementModule['prompt-order2']}
                                        value={time.start}
                                        onChange={(e) => handleTimeWindowChange(index, 'start', e.target.value)}
                                      />
                                      〜
                                      <input
                                        type="time"
                                        className={ManagementModule['prompt-order2']}
                                        value={time.end}
                                        onChange={(e) => handleTimeWindowChange(index, 'end', e.target.value)}
                                      />
                                      <div
                                        className={ManagementModule['delete']}
                                        onClick={() => removeTimeWindow(index)}
                                      >
                                        <DeleteOutlineIcon />
                                      </div>
                                    </div>
                                  ))}
                                  <div className={ManagementModule['add-container']}>
                                    <div className={ManagementModule['add']}>
                                      <AddCircleIcon className={ManagementModule.icon} onClick={addTimeWindow} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <p className={ManagementModule['p-tooltip']}>
                                  {'ユーザーがこのモードを利用できる時間帯を設定します。'}
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className={ManagementModule['prompt-input3']}>
                          <div className={ManagementModule['prompt-input-fields-container1']}>
                            <span className={ManagementModule['sub-field']}>
                              {'モード無効時に履歴画面からの利用を許可する'}
                            </span>
                            <Switch2
                              checked={selectedPrompt.isAvailableWhenDisabled ?? false}
                              onChange={() =>
                                handleInputPromptChange({
                                  isAvailableWhenDisabled: !(selectedPrompt.isAvailableWhenDisabled ?? false)
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className={`${ManagementModule['management-screen-section']}`}>
                        <h3 className={`${ManagementModule['section-title']}`}>スタート時表示設定</h3>
                        <div className={`${ManagementModule['management-screen-row']}`}>
                          <div className={`${ManagementModule['guide-setting-section']}`}>
                            <p className={ManagementModule.label}>ガイドの設定</p>
                            {selectedPrompt.customGuide != null ? (
                              <div className={`${ManagementModule['guide-setting-container']}`}>
                                <textarea
                                  className={ManagementModule['guide-setting-input']}
                                  value={selectedPrompt.customGuide}
                                  onChange={(e) => handleInputPromptChange({ customGuide: e.target.value })}
                                />
                                <div className={`${ManagementModule['guide-setting-button-container']}`}>
                                  <button
                                    className={`${ManagementModule['revert-button']}`}
                                    onClick={() => onGuideChange(null)}
                                  >
                                    デフォルトの
                                    <br />
                                    ガイドに戻す
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className={`${ManagementModule['guide-setting-container']}`}>
                                <p>ガイドは設定されていません。デフォルトのガイドが表示されます。</p>
                                <button
                                  className={ManagementModule['guide-setting-button']}
                                  onClick={() => onGuideChange('')}
                                >
                                  ガイド変更
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              </div>
            </>
          ) : (
            <>
              <div className={ManagementModule.body}>
                <div className={`${ManagementModule['prompt-body-header']} ${ManagementModule['add-folder']}`}>
                  <div className={ManagementModule['button-container']}>
                    <button
                      className={ManagementModule['copy']}
                      onClick={() => {
                        if (!isAuthorizedToCreatePrompt) return
                        if (folderToEdit) {
                          editFolder()
                        } else {
                          addFolder()
                        }
                      }}
                    >
                      {folderToEdit ? '更新' : '作成'}
                    </button>
                    <button
                      className={ManagementModule['copy']}
                      onClick={() => {
                        if (!window.confirm('内容を破棄しますか？')) return
                        setNewFolderTitle('')
                        setFolderToEdit(null)
                        setFolderEditScreenShown(false)
                      }}
                    >
                      キャンセル
                    </button>
                  </div>
                </div>
                <div className={ManagementModule.main} ref={managementModuleRef}>
                  <div className={ManagementModule['prompt-body']}>
                    <p className={ManagementModule.tips}>
                      <span className={ManagementModule['mandatory']}>＊</span>は必須入力です。
                    </p>
                    <p className={ManagementModule.label}>
                      <span className={ManagementModule['mandatory']}>＊</span>フォルダタイトル
                    </p>
                    <textarea
                      key="folder-title"
                      className={ManagementModule['prompt-title']}
                      defaultValue={folderToEdit ? folderToEdit.name : newFolderTitle}
                      onChange={(e) => setNewFolderTitle(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  )
}
export default ManagementScreen
